const errorMessages = {
  default: "Възникна грешка!",
  EC_RefundAlreadyMarked: "За това плащане вече е отбелязано връщане.",

  // Preparatory year schedules (DEOS)
  EC_Preparatory_Schedule_Already_Exists:
    "Вече съществува разписание за тази академична година, учебен план и език на обучение!",
  EC_Invalid_Preparatory_Schedule_Curriculum:
    "Може да се използва само учебният план на ДЕОС, валиден за избраната академична година!",
  EC_Invalid_Preparatory_Schedule_Discipline:
    "Дисциплината не принадлежи на избрания учебен план или е посочена повече от веднъж!",
  EC_Invalid_Preparatory_Schedule_Period_Dates: "Периодът трябва да е в рамките на академичната година!",
  EC_Invalid_Preparatory_Schedule_Period_Times: "Началният час трябва да е преди крайния!",
  EC_Invalid_Preparatory_Schedule_Period_Week_Days:
    "Дните от седмицата трябва да са от понеделник до неделя и без повторения!",
  EC_Invalid_Preparatory_Schedule_Period_Class_Type: "Позволени са само лекции, упражнения и практика!",
  EC_Preparatory_Schedule_Periods_Overlap: "Два периода на една и съща дисциплина се застъпват!",
  EC_Preparatory_Schedule_Room_Conflict: "Залата е заета в част от посочените периоди!",
  EC_Preparatory_Schedule_Professor_Conflict: "Преподавателят е зает в част от посочените периоди!",
  EC_Same_Preparatory_Schedule_Status: "Разписанието вече е в този статус!",
  EC_No_Remote_Exam_Candidacies:
    "В тази кампания няма одобрени кандидатури с дистанционен изпит, за които да се създадат Google акаунти!",
  EC_All_Candidacies_Have_Google_Users: "Всички кандидатури с дистанционен изпит вече имат генерирани Google акаунти!",
  EC_No_Remaining_Candidacies_To_Generate:
    "Няма останали кандидатури за генериране — всички без акаунт са пропуснати след неуспешен опит.",
  EC_Candidacy_Admission_Number_Missing:
    "Има кандидатури без входящ номер. Изчакайте генерирането на входящите номера и опитайте отново.",
  EC_Google_Users_Creation_Failed: "Google акаунтите не можаха да бъдат създадени. Опитайте отново по-късно.",
  EC_MoreThanOneCandidateStudentForPersonIdAndSpecialityFound:
    "Вече съществува кандидат с това ЕГН за тази специалност!",
  EC_Not_Found_Student_Personal_Document: "Няма прикачени лични документи за този студент!",
  EC_CampaignApplicationInvalidGrade: "Невалидна оценка!",
  EC_CampaignRankingAlreadyConfirmed: "Класирането за тази кампания вече е потвърдено!",
  EC_Missing_Argument_ClinicId: "Моля попълнете полето за клиника",
  EC_Not_Found_Hospitality: "Избраната болница не съществува!",
  EC_Missing_Argument_VisibleInCandidateCampaigns: "Моля посочете дали е видима в кандидатстудентски кампании",
  EC_Student_Marked_As_Departed: "Студента вече е отбелязан като пристигнал",
  EC_Invalid_Content: "Моля въведете съдържание",
  EC_Invalid_Location: "Моля въведете локация",
  EC_Invalid_Date: "Моля, въведете бъдеща дата за събитието",
  EC_Status_Waiting_For_Correction: "Не можете да одобрите, когато е в статус 'Очаква корекция'",
  EC_Date_Outside_Year_Period: "Датата е извън периода на академичната година",
  EC_Invalid_Period: "Невалиден период",
  EC_Duplicate_Holiday_Dates: "Има дублиращи се дати!",
  EC_Missing_Argument_Date: "Липсва попълнена дата",
  EC_Missing_Argument_HolidayDate: "Липсва попълнена Дата на празничен ден!",
  EC_Missing_Argument_Description: "Моля попълнете описание",
  EC_Invalid_Cyclic_Schedule_Discipline_Dates: "Невалидни дати! Началната дата не може да бъде по-малка от крайната",
  EC_Invalid_Cyclic_Professor_Times: "Невалидни дати! Началната дата не може да бъде по-малка от крайната",
  EC_Invalid_Cyclic_Professor_Dates: "Невалидни дни! Началният ден не може да бъде по-голям от крайният",
  EC_Invalid_Or_Missing_Professor: "Моля попълнете поле преподавател!",
  EC_Cyclic_Stream_Schedule_Overlap: "Има припокриване на часовете за лекции и упражнения при група",
  EC_Study_Group_Not_In_Stream: "Към този поток не принадлежи въведената учебна група",
  EC_Study_Group_In_Other_Stream: "Въведената учебна група принадлежи към друг поток",
  EC_Invalid_Or_Missing_ClassType: "Моля попълнете тип занятие!",
  EC_Invalid_Operation: "Невалидна заявка",
  EC_Invalid_Session: "Невалидна сесия",
  EC_Not_Found_Structural_Units: "Не е намерена структурна единица",
  EC_Not_Found_Department: "Няма намерен отдел",
  EC_Positions_Not_Found: "Невалидна позиция",
  EC_Tree_Header_Already_Exists: "Невалиден родител",
  EC_Tree_Node_Not_Found: "Невалидна структура",
  EC_Tree_Header_Cannot_Be_Deleted: "Тази част от струкрурата не може да бъде изтрита!",
  EC_Tree_Header_Cannot_Be_Moved: "Тази част от струкрурата не може да бъде преместена!",
  EC_Invalid_Argument_DestinationId: "Невалиден родител",
  EC_Invalid_Argument_AlternateParentId: "Невалиден родител",
  EC_Invalid_Argument_PaymentMethod_PaymentMethod: "Невалиден метод на плащане",
  EC_Invalid_Person_Name: "Липсващи данни в имена",
  EC_InvalidRequest: "Грешно подадени данни!",
  EC_Missing_Argument_CandidateInfo_PersonalDocumentNumber: "Невалиден номер на документ за самоличност",
  EC_NotFound_CandidacySpecialityEntity: "Невалидна специалност",
  EC_Invalid_Argument_CandidateInfo_PersonId: "Невалиден идентификатор",
  EC_UnableToModify_Candidacy_WhichCampaignHasRanking:
    "Не може да бъде модифицирана кандидатура за избраната кампания. Вече има одобрено класиране.",
  EC_Missing_Argument_Name: "Моля попълнете заглавие",
  EC_Internal_Server_Error: "Възникна грешка!",
  EC_Invalid_Argument_FixedAmountLeva: "Невалиден формат на цена в лева.",
  EC_Invalid_Argument_FixedAmountEuro: "Невалиден формат на цена в евро.",
  EC_Unsupported_File_Extension: "Невалиден формат на файл!",
  EC_Invalid_Argument_Courses: "Моля попълнете данни за курсове",
  EC_Missing_Argument_Score: "Моля попълнете бал!",
  EC_Missing_Argument_UserInfoFirstNameEn: "Моля попълнете име на латиница",
  EC_Missing_Argument_UserInfo_FirstNameEn: "Моля попълнете име на латиница",
  EC_Missing_Argument_UserInfoLastNameEn: "Моля попълнете фамилия на латиница",
  EC_Missing_Argument_UserInfo_LastNameEn: "Моля попълнете фамилия на латиница",
  EC_Missing_Argument_ProfilePictureDocumentId: "Няма прикачена профилна снимка!",
  EC_Missing_Argument_OtherUniversityInfo_Disciplines_DisciplinesGrade: "Моля попълнете оценка",
  EC_Invalid_Argument_OtherUniversityInfo_Disciplines_Grade: "Невалидна оценка!",
  EC_Missing_Argument_VisadIssuedOn: "Моля попълнете Дата на издаване на Виза Д",
  EC_NotFound_AnnualFee: "Няма въведена семестриална такса за избраната специалност!",
  EC_Missing_Argument_PersonalDocument_ValidUntil: "Моля попълнете дата на валидност на документ за самоличност!",
  EC_Missing_Argument_PersonalDocument_Number: "Моля попълнете номер на документ за самоличност!",
  EC_Missing_Argument_PersonalDocumentNumber: "Моля попълнете номер на документ за самоличност!",
  EC_File_Already_Exists: "Файлът вече съществува",
  EC_Unable_To_Create_Student_Education: "Не може да създадете запис за този студент!",
  EC_Not_Found_User: "Няма намерен потребител!",
  EC_Missing_Candidacy_Correction_Message: "Моля въведете съобщение!",
  EC_Has_Unsubmitted_Candidacy_Correction: "Вече има изпратена заявка за тази корекция!",
  EC_Deleted_Room_Has_Candidates: "Не можете да премахнете зала в която има кандидати!",
  EC_Invalid_Campaign_Registration_From_Date_Is_Greater_Or_Equal_Than_Registration_To_Date:
    "Датата за начало на регистрация трябва да бъде преди датата за край на регистрация!",
  EC_Invalid_Or_Missing_Id_Card_Detail_Issued_By: "Моля въведете издател на ЛК!",
  EC_Missing_Id_Card_Detail_Data: "Има липсващи данни за ЛК!",
  EC_Id_Card_Detail_Number_Already_Exists: "Вече съществува ЛК с този номер в системата!",
  EC_Has_Active_Campaign_For_Direction_Id:
    "Не може да се променя цена на изпити! Има активни кампании за това направление!",
  EC_Declaration_Date_Not_Provided: "Моля въведете дата от която ще са валидни документите!",
  EC_Campaign_Capacity_Full: "Капацитетът на кампанията е пълен!",
  EC_Email_In_Use: "Имейлът вече се използва от друг потребител!",
  EC_Duplicate_Emails: "Има дублиращи се имейли!",
  EC_Duplicate_Substitute_Request: "Вече има подадена заявка за заместник!",
  EC_Failed_To_Create_User: "Грешка при създаване на потребител в системата!",
  EC_Invalid_PersonId: "Невалидно ЕГН!",
  EC_Person_Id_Invalid: "Невалидно ЕГН!",
  EC_Campaign_Exam_Already_Approved: "Оценките от този изпит вече са финализирани",
  EC_Invalid_File_Format: "Невалидно или непълно съдържание на документа!",
  EC_Invalid_File_Extension: "Невалидно разширение на документа!",
  EC_Campaign_Not_For_Registration: "Кампанията е извън срока за регистрация!",
  EC_Finished_Campaign: "Кампанията е завършена!",
  EC_Already_Finished_Campaign: "Кампанията е приключила!",
  EC_Invalid_Exam_Direction_Price: "Липсват цени за необходимият брой изпити!",
  EC_Required_Argument_IsPaidDocumentProcessing: "Таксата за обработка на документи е ЗАДЪЛЖИТЕЛНА!",
  EC_Unable_To_Approve_Not_Paid_Transactions: 'Не може да одобрите кандидатура с "Не платена" транзакция!',
  EC_EmptyReportData: "Няма налични данни за тази справка!",
  EC_Person_Id_Exists_For_Campaign: "Кандидат с това ЕГН вече съществува в кампанията!",
  EC_MissingRequiredReportFilter: "Моля въведете задължителните параметри за справката!",
  EC_Invalid_Or_Missing_GradingScale_GradeThresholds: "Невалидни стойности в скалата за оценяване!",
  EC_Duplicate_ScoreFormula: "Повтарящ се изпит или учебен предмет!",
  EC_Invalid_ScoreFormula_Multiplier: "Невалидна стойност на множител!",
  EC_Invalid_ScoreFormula: "Невалидна формула за оценяване!",
  EC_Campaign_Duplicate_Exam_Start_Timestamp: "Изпитите не може да са в един и същи ден.",
  EC_Invalid_Campaign_Ranking: "Невалидно класиране!",
  EC_Invalid_Campaign_Ranking_Status: "Класирането не е одобрено!",
  EC_Additional_Capacity_Unsupported_Ranking_Type:
    "Добавяне на допълнителни места не се поддържа за класиране по договор с болница!",
  EC_Ranking_Not_In_Enrollment_Period: "Класирането не е в период на записване!",
  EC_Invalid_Additional_Capacity_Values: "Невалидни стойности за допълнителни места!",
  EC_Additional_Capacity_Candidate_Conflict: "Кандидати, които вече имат място в кампанията:",
  EC_Invalid_Ranking_Type_For_Campaign: "Невалиден тип класиране за този тип кампания!",
  EC_Child_Campaign_Ranking_Not_Approved:
    "Класирането на свързаната кампания все още не е одобрено. Одобрете го, преди да изготвите това класиране!",
  EC_SessionExam_Duplicate_Professors: "Повтарящ се преподавател!",
  EC_Overlapping_ProfessorScheduleWeeks: "Има припокриващи се седмици избраните преподаватели!",
  EC_Too_Early_To_Generate_Ranking: "Твърде рано е за изготвяне на класиране!",
  EC_Campaign_Exams_Results_Not_Approved: "Резултатите от всички изпити трябва да са финализирани!",
  EC_Invalid_Campaign_Ranking_Schedule: "Невалидно разписание за класиране на кампанията!",
  EC_Invalid_Campaign_Specialities: "Невалидни специалности за кампанията!",
  EC_Invalid_Speciality_Capacity: "Невалиден капацитет за специалността!",
  EC_Invalid_Campaign_Capacities: "Невалидни капацитети за кампанията!",
  EC_Invalid_Exam_Type_Id: "Невалиден тип на изпита!",
  EC_Invalid_Exam_Category_Id: "Невалидна категория на изпита!",
  EC_Required_Regular_Campaign_Exam_Start_Date_Timestamp: "Датите на изпита са задължителни!",
  EC_Required_Regular_Campaign_Exam_Start_Hour_Timestamp: "Датите за начало на изпит са задължитени!",
  EC_Invalid_Campaign_Exam_Start_Date: "Датата за начало на изпит трябва да е след датата за край на кампания!",
  EC_Required_Regular_Campaign_Spoken_Exam_End_Time: "Датата за край на устен изпит е задължителна!",
  EC_Required_Regular_Campaign_Spoken_Exam_Capacity: "Капацитетът за устен изпит е задължителен!",
  EC_Invalid_Direction_Id: "Невалидно направление!",
  EC_Attestation_UnableToSignOff_HasNotSignedOffExercises: "Студентът все още няма заверка за упражнения!",
  EC_Invalid_Campaign_Type: "Невалиден тип на кампания!",
  EC_Invalid_Campaign_Registration_Dates: "Датата за начало на кампания е невалидна!",
  EC_Exam_Slot_Not_Found: "Невалидно място за изпита!",
  EC_Invalid_Department_Id: "Невалидна катедра!",
  EC_Invalid_Or_Missing_Direction_Id: "Невалидно или липсващо направление!",
  EC_Not_Found_AcademicYear: "Няма намерена учебна година!",
  EC_Not_Found_Curriculum: "Няма намерен учебен план!",
  EC_Not_Enough_Score_For_Paid_Campaign: "Балът на кандидата е под минимално изискуемия за специалността!",
  EC_DuplicateEntry_StudentSportActivityEntity: "Разписанието се дублира!",
  EC_NotFound_SportActivityEntity: "Спортното разписание не съществува!",
  EC_AcademicSessionHasEnded: "Избраният семестър е приключил",
  EC_AcademicSessionNotExist: "Избраният семестър не съществува",
  EC_AcademicSessionIsNotSemester: "Невалидна стойност за семестър",
  EC_Unable_To_Transfer_Candidacy_Payments: "Не може да се прехвърлят плащанията на кандидатурата!",
  EC_Unable_To_Transfer_Candidacy_Payments_Diff_Amounts:
    "Не може да се прехвърлят плащанията на кандидатурата с различни суми!",
  EC_WeeklySchedule_AlreadyExists: "Вече съществува седмично разписание за въведените параметри!",
  EC_Multiple_Expected_Payments: "Не може да има повече от 1 очаквано плащане.",
  EC_WeeklySchedule_ProfessorWeeks_ShouldBe15: "Липсват преподаватели за всяка от седмиците (1-15)!",
  EC_ProfessorWeeks_ShouldMatch_ScheduleWeeks:
    "Седмиците на преподавателя трябва да съответстват със седмиците за разписанието!",
  EC_WeeklySchedule_Stream_Row_Not_Editable: "Занятията в поток се редактират само през екран 'Занятия в поток'!",
  EC_Invalid_Argument_StudyGroups: "Невалидни учебни групи!",
  EC_Invalid_Argument_SplitAcrossGroups: "Разделянето по групи не е позволено за занятия в поток!",
  EC_Invalid_Argument_CurriculumIds: "Седмичните разписания не могат да се определят еднозначно за всеки учебен план!",
  EC_Incomplete_Order_Data_For_Speciality_Ranking: "Липсват данни за заповед за някоя от специалностите!",
  EC_Third_Party_Login_Failed: "Входът с Google не беше успешен. Опитайте отново.",
  EC_Missing_Argument_StudyGroups: "Моля, добавете учебни групи!",
  EC_AcademicSession_Already_Published: "Академичната сесия е вече финализирана!",
  EC_Date_Outside_Academic_Year_Period: "Моля изберете бъдеща дата. Датата, която избрахте вече е минала!",
  EC_SessionExam_Conflict_Room_Time_Slots: "Залата е заета в този часови диапазон",
  EC_SessionExam_Conflict_Professor_Time_Slots: "Преподавателят е зает в този часови диапазон",
  EC_Study_Groups_Already_In_Exam: "Учебната група е отбелязана за друг изпит",
  EC_UnableToModifyStartedOrCompleted_SessionExam: "Не е възможно да редактирате започнал или приключил изпит",
  EC_Invalid_Argument_FromFacultyNumber: "Невалидна стойност за факултетен номер",
  EC_Missing_Argument_StudentsCapacity: "Моля, въведете стойност за студентски капацитет или факултетен номер",
  EC_Missing_Argument_OrderDate: "Моля въведете дата на заповед!",
  EC_Missing_Argument_EducationSemesterIds: "Моля изберете семестри за прекъсване!",
  EC_Wrong_Semester_Status: "Неподходящ статус на някой от избраните семестри за тази операция!",
  EC_No_Missing_Attestations_Found: "Няма липсващи заверки за някой от избраните семестри!",
  EC_Phone_Number_Invalid: "Моля, въведете валиден телефонен номер",
  EC_Missing_Argument_OtherUniversityInfo_Disciplines_Grade:
    "Липсва оценка по дисциплина отбелязана като взета в предишния университет",
  EC_Weekly_Schedule_Room_Time_Conflict: "Залата е заета в този диапазон",
  EC_Weekly_Schedule_Professor_Time_Conflict: "Преподавателят е зает в този диапазон",
  EC_Weekly_Schedule_Study_Group_Time_Conflict: "Учебната група е заета в този диапазон",
  EC_WeeklySchedule_Professor_Time_Conflict: "Преподавателят е зает в този диапазон",
  EC_Duplicate_Professor: "Дублиращ се преподавател в различни комисии",
  EC_ClassAttendance_CanBeMarked_Only_For_Today:
    "Присъствия могат да се отбелязват само в деня на провеждане на занятието",
  EC_Same_Education_Status: "Моля, сменете статуса",
  EC_Campaign_Alredy_Exists: "Кампанията вече съществува!",
  EC_Invalid_Start_Or_EndDate_Application: "Невалидна дата за кандидатстване!",
  EC_Invalid_Start_Or_EndDate_FamilyIncome: "Невалидна дата за предоставяне на документи за доход!",
  EC_Invalid_Argument_SemestersForGradeCalculation: "Невалидна стойност за брой семестри за среден успех!",
  EC_Invalid_Argument_MaxIncomePerFamilyMember: "Невалидна стойност за средно-месечен доход",
  EC_Conflicting_Curriculum_Topics: "Не може да се създават няколко теми за една и съща седмица!",
  EC_Staff_Request_Payload_Invalid: "Невалидни данни за заявка за отсъствие!",
  EC_Staff_Request_Unable_To_Determine_Approver: "Не може да бъде определен одобряващ за заявката!",
  EC_Staff_Request_Already_Processed: "Заявката вече е обработена и не може да бъде променена!",
  EC_Staff_Request_Already_Started: "Заявката не може да бъде отменена, защото периодът ѝ вече е започнал!",
  EC_Staff_Request_Assigned_To_Other_User: "Заявката е възложена на друг потребител!",
  EC_Invalid_StatusReason: "Невалиден статус за заявка!",
  EC_Invalid_Employee_Substitute: "Невалидно избран заместник!",
  EC_Employee_Or_Substitute_Not_Found: "Невалиден служител или заместник!",
  EC_Substitute_Already_On_Leave: "Избраният заместник вече е в отпуск или болничен за този период!",
  EC_Leave_Period_Is_Required: "Периодът на отпуск е задължителен!",
  EC_Leave_Request_Not_Approved: "Само одобрени отпуски могат да бъдат коригирани!",
  EC_Leave_Reason_Cannot_Be_Canceled: "Основанието на тази отпуска не позволява отмяна!",
  EC_Missing_Argument_Reason: "Моля, въведете основание за отпуск!",
  EC_Sick_Leave_Already_Exist: "Вече съществува болничен за този период!",
  EC_Business_Trip_Request_Already_Exist: "Вече съществува командировка за този период!",
  EC_Leave_Request_Already_Exist: "Вече съществува заявка за отпуск за този период!",
  EC_Leave_Contract_Required: "Изберете поне един трудов договор!",
  EC_Invalid_Leave_Contract_Selection: "Невалиден избор на трудов договор!",
  EC_Missing_Argument_DailyAllowanceDays: "Моля, въведете стойност за дневни пари!",
  EC_Missing_Argument_NightsCount: "Моля, въведете стойност за брой нощувки!",
  EC_Business_Trip_Locations_Are_Required: "Моля, изберете локации за командировка!",
  EC_Country_Id_Is_Required_For_Abroad: "Моля, изберете държава за международна командировка!",
  EC_Settlement_Name_Is_Required_For_Abroad: "Моля, въведете име на населено място за международна командировка!",
  EC_Settlement_Id_Is_Required_For_Domestic: "Моля, изберете населено място за вътрешна командировка!",
  EC_Employee_Not_Found: "Служителят не е намерен!",
  EC_Invalid_Argument_DailyAllowanceDays: "Невалидна стойност за дневни пари!",

  // Business trips — travelers
  EC_Business_Trip_Travelers_Are_Required: "Моля, добавете поне един пътуващ!",
  EC_Business_Trip_Traveler_Full_Name_Is_Required: "Моля, въведете име на външното лице!",
  EC_Business_Trip_Duplicate_Traveler: "Служителят е добавен повече от веднъж!",
  EC_Business_Trip_Traveler_Types_Cannot_Be_Mixed:
    "Не може да се смесват служители и външни лица във вътрешна командировка!",
  EC_Business_Trip_Domestic_Category_Is_Required: "Моля, изберете категория за вътрешна командировка!",
  EC_Business_Trip_Domestic_Category_Not_Allowed_For_Abroad: "Категорията се попълва само за вътрешна командировка!",
  EC_Business_Trip_Jury_Contract_Is_Required: "Моля, въведете номер и дата на договора!",
  EC_Business_Trip_Employer_Consent_Is_Required: "Необходимо е съгласие от другия работодател!",
  EC_Business_Trip_Employer_Fields_Only_Allowed_For_Jury:
    "Данните за друг работодател се попълват само за членове на научни жури!",
  EC_Business_Trip_Contract_Fields_Only_Allowed_For_Jury:
    "Данните за договор се попълват само за членове на научни жури!",
  EC_Business_Trip_Student_Fields_Only_Allowed_For_Student:
    "Данните за факултет се попълват само за студенти и докторанти!",
  EC_Business_Trip_Student_Faculty_Is_Required: "Моля, въведете факултет на студента/докторанта!",
  EC_Business_Trip_Employee_Id_Not_Allowed_For_Category:
    "За този тип вътрешна командировка пътуващият не може да бъде избран служител!",
  EC_Business_Trip_Abroad_Traveler_Type_Cannot_Be_Mixed:
    "Попълнете или данни за договор, или данни за факултет — не и двете!",
  EC_Business_Trip_Abroad_Traveler_Type_Is_Required:
    "Моля, попълнете данни за договор или данни за факултет на пътуващия!",
  EC_Invalid_Argument_Assignment: "Невалидна стойност за задача (до 500 символа)!",
  EC_Invalid_Argument_ExpensePayer: "Невалидна стойност за платец на разходите (до 300 символа)!",
  EC_Invalid_Argument_Faculty: "Невалидна стойност за факултет (до 200 символа)!",
  EC_Invalid_Argument_FacultyNumber: "Невалидна стойност за факултетен номер (до 50 символа)!",
  EC_Invalid_Argument_AverageFuelConsumption: "Невалидна стойност за среден разход на гориво!",
  EC_Invalid_Argument_DistanceInKm: "Невалидна стойност за разстояние!",

  EC_ScheduleStudyGroupCoverageInvalid: "Учебните групи по служители не може да се припокриват!",
  EC_ScheduleOverlappingCycles: "Припокриващи се дати за цикли!",
  EC_ScheduleEmployeeTimeConflict: "Преподавателят е зает в този диапазон",
  EC_Disciplines_Not_Found: "Дисциплините не са намерени",
  EC_Curriculum_Not_Found: "Учебният план не е намерен",
  EC_Campaign_Not_Found: "Кампанията не е намерена",
  EC_Campaign_Added: "Кампанията вече е добавена",
  EC_Application_Not_Found: "Заявлението не е намерено",
  EC_NotFound_IncomingEmployeeEntity: "Пристигащият преподавател не е намерен",
  EC_NotFound_OutgoingEmployeeEntity: "Заминаващият преподавател не е намерен",
  EC_Coordinator_Not_Found: "Не е намерен координатор",
  EC_Application_Closed: "Заявлението е заключено и не може да бъде редактирано",
  EC_Invalid_Absence_Period: "Невалиден период на отсъствие! Крайната дата не може да е преди началната.",
  EC_UserId_Not_Found: "Потребителят не е намерен",
  EC_University_Not_Found: "Университетът не е намерен",
  EC_Student_Not_Found: "Студентът не е намерен",
  EC_Document_Not_Found: "Документът не е намерен",
  EC_Invalid_Parameter_Name: "Невалидно име на документ (задължително, до 200 символа)",
  EC_Invalid_Parameter_File: "Липсва или е невалиден файл",
  EC_Student_Server_Error: "Грешка в сървъра при обработка на студент",
  EC_Administration_Server_Error: "Грешка в сървъра",
  EC_Commission_Members_Not_Found: "Членовете на комисията не са намерени",
  EC_No_Access: "Нямате достъп",
  EC_Employee_Server_Error: "Грешка в сървъра при обработка на служител",
  EC_Invalid_Time: "Невалидно дата",
  EC_Student_Marked_As_Arrived: "Студентът е отбелязан като пристигнал",
  EC_Education_Is_Required: "Образованието е задължително",
  EC_Invalid_Disciplines: "Невалидни дисциплини",
  EC_Missing_Argument_AcademicYearId: "Моля изберете учебна година!",
  EC_Invalid_Parameter_DisciplineId: "Невалидна дисциплина!",
  EC_Invalid_Parameter_Semester: "Невалиден семестър!",
  EC_Invalid_Parameter_StudyGroup: "Невалидна учебна група!",
  EC_Invalid_User: "Невалиден потребител",
  EC_Invalid_Citizenship: "Невалидно гражданство",
  EC_Invalid_Student: "Невалиден студент",
  EC_Departments_Not_Found: "Катедрите не са намерени",
  EC_Invalid_Status: "Невалиден статус",
  EC_Invalid_Duration: "Невалидна продължителност",
  EC_Document_Server_Error: "Грешка в сървъра при обработка на документ",
  EC_Missing_File: "Липсва файл",
  EC_Invalid_Permission: "Невалидно разрешение",
  EC_Enum_Not_Found: "Стойността не е намерена",
  EC_NotFoundPlanForSpeciality: "Няма намерен стажантски план за избраната специалност!",
  EC_MoreThanOnePlanForSpecialityFound: "Има повече от един стажантски план за избраната специалност!",
  EC_ScheduleIndividualCycleDuplicateStudent: "Студента се дублира за индивидуално циклично разписание!",
  EC_SpecialistUserWithSamePersonIdExists: "Потребител със същото ЕГН вече съществува!",
  EC_SpecialistNoCurriculumForSpecialization:
    "Няма създаден учебен план за специалността, в която се опитвате да запишете специализант!",
  EC_Invalid_Argument_PersonId: "Невалиден идентификатор (ЕГН, ЛНЧ, ПИД)!",
  EC_CurriculaPrerequisiteAlreadyExists: "Предпоставката се дублира!",
  EC_NotFound_CampaignRankingEntity: "Не е намерено класиране за кампанията",
  EC_Invalid_Argument_ValidFrom: "Датата трябва да бъде днешна или след днешната!",
  EC_Unable_To_MadeUp_Class_Student_Must_Request: "Студентът трябва да подаде заявка за отработване",

  // Specialist service — members / contact validation
  EC_MissingEmployeeOrEmployeeNames: "Моля, попълнете служител или имена на външен член!",
  EC_ConflictEmployeeOrEmployeeNames: "Не може едновременно служител и имена на външен член!",
  EC_MissingUniversityOrBuildingId: "Моля, изберете университет или сграда!",
  EC_ConflictUniversityOrBuildingId: "Не може едновременно университет и сграда!",

  // Healthcare courses / campaigns
  EC_HealthcareCourseDailyPriceExistsForYear: "Вече съществува дневна цена за този курс за избраната година!",
  EC_HealthcareCourseNotAvailableInRequestedYear: "Курсът не е наличен за избраната година!",
  EC_HealthcareCampaignIsNotAcceptingApplications: "Кампанията не приема заявления в момента!",
  EC_HealthcareApplicationImpossibleStatusTransition: "Невъзможна промяна на статуса на заявлението!",
  EC_AlreadyExistsHealthcareApplicationWithSamePersonId: "Вече съществува заявление с това ЕГН, но с различен УИН!",
  EC_AlreadyExistsHealthcareApplicationWithSameUin: "Вече съществува заявление с този УИН, но с различно ЕГН!",
  EC_HealthcareApplicationDesiredDateOutsideCourseYear:
    "Желаната начална дата трябва да е в бъдещето и в рамките на годината на курса!",
  EC_TooLong_Argument_FirstName: "Името трябва да е до 30 символа!",
  EC_TooShort_Argument_FirstName: "Името трябва да е поне 2 символа!",
  EC_TooLong_Argument_SecondName: "Презимето трябва да е до 30 символа!",
  EC_TooShort_Argument_SecondName: "Презимето трябва да е поне 2 символа!",
  EC_TooLong_Argument_LastName: "Фамилията трябва да е до 30 символа!",
  EC_TooShort_Argument_LastName: "Фамилията трябва да е поне 2 символа!",
  EC_TooLong_Argument_Uin: "УИН трябва да е до 20 символа!",
  EC_TooLong_Argument_Clinic: "Клиниката трябва да е до 300 символа!",
  EC_TooLong_Argument_Email: "Имейлът трябва да е до 200 символа!",
  EC_HealthcareCourseFeeDistributionPercentagesSumMustBe100:
    "Сборът на процентите за разпределение на таксата трябва да е 100!",

  // Postgraduate courses
  EC_PostgraduateCoursesYearAlreadyFinalized: "Годината за следдипломни курсове вече е финализирана!",
  EC_PostgraduateCoursesDuplicateDefinition: "Дублираща се дефиниция на следдипломен курс!",
  EC_PostgraduateCoursesClinicNotExists: "Избраната клиника не съществува!",
  EC_PostgraduateCoursesClinicDontHaveDepartment: "Избраната клиника няма катедра!",

  // Specialist campaigns
  EC_CampaignSpecializationOptionInvalid: "Невалидна опция за специалност в кампанията!",
  EC_CampaignExamsMismatch: "Несъответствие на изпитите за кампанията!",
  EC_CampaignTaxesIncomplete: "Непълни такси за кампанията!",
  EC_CampaignMustHaveSingleDocumentProcessingTax:
    "Кампанията трябва да има точно една такса за обработка на документи!",
  EC_SpecialistsCampaignRegistrationOverlap: "Припокриване на периодите за регистрация на кампании!",
  EC_UnableToCalculateCampaignApplicationFee: "Не може да се изчисли таксата за заявлението!",

  // Specialist campaign applications
  EC_CampaignApplicationInvalidCandidateShape: "Невалидни данни за кандидата!",
  EC_CampaignApplicationEmployeesOnlyViolation: "Заявлението е допустимо само за служители!",
  EC_CampaignApplicationEmployeeNotFound: "Служителят не е намерен!",
  EC_CampaignApplicationSpecializationOptionNotInCampaign: "Избраната специалност не е част от кампанията!",
  EC_CanNotPickDuplicateSpecializationOptions: "Не може да изберете дублиращи се специализации!",
  EC_CampaignApplicationPriorityInvalid: "Невалиден приоритет на заявлението!",
  EC_CampaignApplicationImpossibleStatusTransition: "Невъзможна промяна на статуса на заявлението!",
  EC_CampaignApplicationHasUnpaidDebts: "Заявлението има неплатени задължения!",
  EC_CampaignApplicationCorrectionRequestEmpty: "Заявката за корекция е празна!",
  EC_CampaignApplicationCorrectionInvalidDocumentType: "Невалиден тип документ за корекция!",
  EC_CampaignApplicationCorrectionAlreadyConsumed: "Корекцията вече е използвана!",
  EC_CampaignApplicationHasUnsubmittedCorrection: "Има неизпратена корекция по заявлението!",
  EC_CampaignApplicationGradeRequired: "Оценката е задължителна!",

  // Authentication / registration
  EC_InvalidOrMissingEmail: "Невалиден или липсващ имейл!",
  EC_EmailInUse: "Имейлът вече се използва!",
  EC_NotSatisfiedPasswordPolicy: "Паролата не отговаря на изискванията!",
  EC_NoCampaignForRegistration: "Няма кампания за регистрация!",
  EC_MoreThanOneCampaignForRegistration: "Има повече от една кампания за регистрация!",
  EC_RegistrationSpecializationEmployeesOnly: "Тази специалност е достъпна само за служители!",
  EC_RegistrationStructuralUnitNotAvailable: "Структурната единица не е налична!",
  EC_Candidate_User_With_Same_Person_Id_Exists: "Кандидат с това ЕГН вече съществува!",
  EC_Invalid_ReCaptcha: "Невалиден ReCaptcha! Моля, опитайте отново.",

  // Campaign documents / workflow
  EC_CampaignDocumentWorkflowNotFound: "Не е намерен документен процес за кампанията!",
  EC_CampaignDocumentTypeNotRequired: "Този тип документ не е изискуем!",
  EC_CampaignWorkflowMissingDocument: "Липсва документ за процеса!",
  EC_CampaignDocumentUploadFailed: "Неуспешно качване на документа!",

  // Payments
  EC_Invalid_Payment_Amount: "Невалидна сума на плащане!",
  EC_Invalid_Payment_Type: "Невалиден тип плащане!",
  EC_Unable_To_Create_Debt: "Не може да се създаде задължение!",

  // Campaign exam slot
  EC_CampaignExamSlotAlreadyExists: "Вече съществува място за изпит!",

  // Curricula
  EC_CurriculaWrongTypeForModulesItems: "Неподходящ тип учебен план за модули и елементи!",
  EC_CurriculaWrongTypeForCourses: "Неподходящ тип учебен план за курсове!",
  EC_CurriculaCoursesRequired: "Курсовете са задължителни!",
  EC_CurriculaModulesItemsForbidden: "Модули и елементи не са позволени за този учебен план!",
  EC_CurriculaCoursesForbidden: "Курсове не са позволени за този учебен план!",
  EC_CurriculaDuplicateCourseDefinition: "Дублираща се дефиниция на курс!",
  EC_CurriculaCourseDefinitionAlreadyAdded: "Дефиницията на курса вече е добавена!",
  EC_Invalid_CurriculumModule: "Избран е модул, който не принадлежи на избраната дисциплина от учебния план!",
  EC_CurriculumModule_Mandatory: "Дисциплината е разделена на модули - изберете модул.",
  EC_Duplicate_CurriculumModules: "Един и същ модул е избран в повече от една дисциплина!",

  // Curricula — duplicates in a saved collection
  EC_Duplicate_CurriculumDiscipline: "Една и съща дисциплина е добавена повече от веднъж!",
  EC_Duplicate_DisciplineCredit: "Дублиращи се кредити за дисциплина — повтарят се националност и език на преподаване!",
  EC_Duplicate_DisciplineSchedule: "Дублиращо се разписание — един и същ семестър е въведен повече от веднъж!",
  EC_Duplicate_CurriculumInternship: "Един и същ стаж е добавен повече от веднъж!",

  // Specialist exam committees
  EC_UnableToActivateAlreadyActiveSpecialistsExamCommittees: "Изпитната комисия вече е активна!",
  EC_UnableToDeactivateAlreadyDeactivatedSpecialistsExamCommittees: "Изпитната комисия вече е деактивирана!",

  // Specialist
  EC_SpecialistEstimationRequiredForColloquium: "Необходима е оценка за колоквиум!",
  EC_SpecialistCurriculumItemNotInCurriculum: "Елементът не е част от учебния план!",
  EC_SpecialistInvalidIdentityShape: "Невалидни идентификационни данни на специализанта!",
  EC_SpecialistReceptionTypeNotInSpecialization: "Видът прием не е наличен за тази специалност!",
  EC_SpecialistAlreadyEnrolled: "Специализантът вече е записан!",
  EC_SpecialistCompletionInvalidPayloadForType: "Невалидни данни за този тип завършване!",
  EC_SpecialistCompletionInvalidGrade: "Невалидна оценка!",
  EC_SpecialistCompletionInvalidDateRange: "Невалиден период от дати!",
  EC_SpecialistCompletionInvalidHours: "Невалиден брой часове!",
  EC_SpecialistCompletionEmployeesRequired: "Необходими са служители!",
  EC_SpecialistCompletionCommitteeRequired: "Необходима е комисия!",
  EC_SpecialistCompletionIsPossibleOnlyInActiveStatus: "Завършване е възможно само в активен статус!",

  // Curricula prerequisites
  EC_CurriculaPrerequisiteSelfReference: "Елементът не може да бъде предпоставка на себе си!",
  EC_CurriculaPrerequisiteCycle: "Открита е циклична зависимост между предпоставките!",

  // Campaign exam results
  EC_CampaignExamResultsMissingApplications: "Липсват заявления за резултатите от изпита!",
  EC_CampaignExamResultsUnexpectedApplications: "Има неочаквани заявления за резултатите от изпита!",
  EC_CampaignExamResultGradeNotAllowed: "Оценката не е позволена!",
  EC_CampaignExamResultGradeRequired: "Оценката е задължителна!",
  EC_CampaignExamResultInvalidDisqualifiedGrade: "Невалидна оценка за дисквалифициран!",
  EC_CampaignExamResultInvalidGradeRange: "Оценката е извън допустимия диапазон!",
  EC_CampaignExamResultsAlreadyExist: "Резултатите от изпита вече съществуват!",

  // Campaign ranking
  EC_CampaignRankingNotInDraft: "Класирането не е в чернова!",
  EC_CampaignRankingApprovedApplicationsMissingDiplomaGrade: "На одобрени заявления липсва оценка от диплома!",
  EC_CampaignRankingApprovedApplicationsMissingExamResult: "На одобрени заявления липсва резултат от изпит!",
  EC_Paid_Ranking_Not_Allowed_For_Direction:
    "Платено класиране не е позволено за направление с отделна платена кампания!",
  EC_State_Ranking_Locked_By_Paid_Ranking:
    "Не може да се преизготви класиране по държавна поръчка след като е изготвено платено класиране!",

  // Training buildings
  EC_TrainingBuildingAlreadyExists: "Базата за обучение вече съществува!",
  EC_NotFoundTrainingBuilding: "Базата за обучение не е намерена!",
  EC_TrainingBuildingHasExpiredAccreditation: "Базата за обучение има изтекла акредитация!",

  // Specialist status / graduation
  EC_SpecialistImpossibleStatusTransition: "Невъзможна промяна на статуса на специализанта!",
  EC_SpecialistEligibilityForGraduationFileRequired: "Необходимо е да прикачите файл!",
  EC_SpecialistEligibilityForGraduationDocumentUploadFailed: "Неуспешно качване на документа!",
  EC_SpecialistNoActiveExamCommitteeAvailable: "Няма налична активна изпитна комисия!",
  EC_SpecialistExamCommitteeChangeRequiresGraduating:
    "Смяна на изпитна комисия е възможна само в статус 'Дипломиране'!",
  EC_SpecialistExamCommitteeNotAssignable: "Изпитната комисия не може да бъде назначена!",
  EC_SpecialistFinalExamsRequireGraduating: "Финалните изпити изискват статус 'Дипломиране'!",
  EC_SpecialistFinalExamsIncomplete: "Финалните изпити са непълни!",
  EC_SpecialistFinalExamInvalidGradeRange: "Оценката от финалния изпит е извън допустимия диапазон!",

  // Doctoral campaigns
  EC_DoctoralCampaignOverlapsForStructuralUnit:
    "Вече съществува докторантска кампания за този факултет в избрания период. Не може да има две припокриващи се кампании за един и същи факултет.",
  EC_DoctoralCampaignStructuralUnitMismatch: "Избраните места не принадлежат към избрания факултет.",
  EC_DoctoralCampaignStructuralUnitNotEligible: "Избраният факултет няма активна докторантска кампания.",
  EC_DoctoralExamSchedulingNotAllowed: "Няма допуснати кандидати за тази дисциплина.",
  EC_DoctoralExamDateTooSoon: "Датата на изпита трябва да е поне 1 месец след създаването на комисията.",
  EC_DoctoralExamRoomInvalid: "Избраната зала е невалидна.",
  EC_DoctoralExamCommitteeApproverNotDean: "Само Деканът на факултета може да утвърди комисията.",
  EC_DoctoralExamCommitteeNotApproved: "Първо изберете и утвърдете изпитна комисия.",
  EC_DoctoralLanguageExamCommitteeNotSet: "Първо изберете изпитна комисия по език.",
  EC_DoctoralLanguageExamNotScheduled: "Първо насрочете изпита по език за избрания език на кандидата.",
  EC_DoctoralExamGradeEntryNotAuthorized: "Само членове на изпитната комисия могат да въвеждат оценки.",
  EC_DoctoralExamGradeInvalidRange: "Оценката трябва да е между 2.00 и 6.00.",
  EC_DoctoralExamOralLocked:
    "Устният изпит се отключва след като и тримата членове въведат писмени оценки със среден успех над 4.50.",
  EC_DoctoralExamGradesLockedAfterRanking: "Оценките не могат да се променят след одобрено класиране.",

  // Doctoral defense
  EC_DoctorantNotEligibleForDefense: "Докторантът не е в статус, който позволява защита.",
  EC_DefenseJuryChairmanRequired: "Журито трябва да има точно един председател.",
  EC_DefenseJuryReviewerRequired: "Журито трябва да има точно един рецензент.",
  EC_DefenseJuryMemberInvalid: "Невалиден член на журито — попълнете служител или външен член.",
  EC_DefenseNotFound: "Няма намерена защита за този докторант.",
  EC_DefenseNotScheduled: "Защитата все още не е насрочена.",
  EC_DefenseDateNotPassed: "Резултат може да се въведе само след датата на защитата.",
  EC_DefenseResultNotChairman: "Само председателят на журито или администратор може да въведе резултат.",
  EC_DefenseRoomBuildingMismatch: "Избраната зала не принадлежи на избраната сграда.",
  EC_DoctorantReportProtocolDateInFuture: "Датата на протокола не може да бъде в бъдещето.",
  EC_DoctorantDismissalProtocolDateInFuture: "Датата на протокола не може да бъде в бъдещето.",
  EC_DoctorantSupervisorsUnchanged: "Няма промяна в научните ръководители.",
  EC_NoOpenDefenseAttempt: "Няма активен опит за защита.",

  // Advanced specialization specialist
  EC_AdvancedSpecializationSpecialistInvalidDiscount: "Процентът отстъпка трябва да е между 0 и 100.",
  EC_AdvancedSpecializationSpecialistInvalidPeriodDuration: "Продължителността в дни трябва да е по-голяма от 0.",
  EC_AdvancedSpecializationSpecialistPeriodExceedsDuration:
    "Сборът от дните на периодите надхвърля максималния лимит за обучението.",
  EC_AdvancedSpecializationSpecialistPreviousPeriodNotPaid:
    "Предишният период трябва да е маркиран като платен, преди да добавите нов.",
  EC_AdvancedSpecializationSpecialistPeriodAlreadyPaid: "Този период вече е маркиран като платен.",
  EC_AdvancedSpecializationSpecialistBuildingNotInSpecialization:
    "Избраната сграда не е сред сградите на тази специалност.",
  EC_AdvancedSpecializationSpecialistProfessorNotInSpecialization:
    "Избраният преподавател не е сред преподавателите на тази специалност.",
  EC_AdvancedSpecializationSpecialistAdditionalTrainingRequiresFullCoverage:
    "Допълнително обучение може да се добави само след като периодите покрият цялата продължителност на обучението.",
  EC_AdvancedSpecializationSpecialistAdditionalTrainingProtocolRequired: "Прикачете изпитния протокол.",
  EC_AdvancedSpecializationSpecialistReferralAlreadyGenerated: "За този период вече е генерирано направление.",
  EC_AdvancedSpecializationSpecialistReferralGenerationFailed:
    "Генерирането на направлението не бе успешно. Опитайте отново.",
  EC_AdvancedSpecializationSpecialistProtocolUploadFailed: "Качването на протокола не бе успешно. Опитайте отново.",
  EC_AdvancedSpecializationSpecialistAlreadyGraduated:
    "Специализантът вече е завършил и не може да се качи нов протокол.",
  EC_AdvancedSpecializationSpecialistFinalExamRequiresFullCoverage:
    "Протокол от финален изпит може да се качи само след като периодите покрият цялата продължителност на обучението.",
  EC_AdvancedSpecializationSpecialistFinalExamProtocolRequired: "Прикачете протокола от финалния изпит.",
  EC_NotFound_AdvancedSpecializationSpecialistEntity: "Специализантът не е намерен.",

  // Erasmus applications
  EC_Invalid_Correction_Fields: "Невалиден параметър за корекция",
  EC_Missing_Correction_Fields: "Моля, изберете поне един документ за корекция!",
  EC_Invalid_Parameter_Message: "Моля, въведете съобщение!",
  EC_Invalid_Parameter_Status: "Непозволена промяна на статуса!",
  EC_Invalid_Parameter_Start: "Моля, въведете начална дата!",
  EC_Invalid_Parameter_End: "Моля, въведете крайна дата!",
  EC_Invalid_Parameter_University: "Моля, изберете университет!",
  EC_Invalid_Parameter_Id: "Невалиден идентификатор!",
  EC_Invalid_Parameter_FundingTranchesDto: "Моля, въведете финансиране!",
  EC_Invalid_Parameter_TotalAmount: "Моля, въведете сума!",
  EC_Invalid_Parameter_RejectionComment: "Коментарът не може да бъде по-дълъг от 2000 символа!",

  // Erasmus incoming employees

  // Budget
  EC_Budget_Alredy_Exists: "Вече има бюджет за този факултет и година!",

  // Enrollment — curriculum
  EC_Missing_Argument_CurriculumId: "Моля, изберете учебен план!",
  EC_Invalid_Argument_NotAllowed_FormType_CurriculumId:
    "Учебен план не се допуска за този критерий за записване на студент!",
  EC_NotFound_CurriculumId: "Избраният учебен план не е намерен!",
  EC_Invalid_Argument_CurriculumId:
    "Избраният учебен план не съответства на специалността, вида на обучение и приема след ниво на образование!",
  EC_Missing_Argument_NewCurriculumId: "Моля, изберете нов учебен план!",
  EC_NotFound_Curriculum: "Избраният учебен план не е намерен!",
  EC_Curriculum_Does_Not_Belong_To_Speciality: "Избраният учебен план не принадлежи на специалността на студента!",
  EC_Missing_Argument_ResidenceSettlementId: "Моля, изберете населено място по постоянен адрес!",
  EC_Invalid_Argument_currentSemesterType:
    "Справката за 'Справка среден успех за стипендии' може да бъде съставена само по време на зимен/летен семетър!",

  // Campaigns — hospital contracts
  EC_Admin_Candidacy_Forbidden_For_Hospital_Contract:
    "Кандидатурите по договор с болница се подават само от кандидата през портала — не могат да се създават от администратор!",
  EC_Candidacy_Correction_Fields_Require_Hospital_Contract:
    "Корекция на декларации и болница може да се изисква само за кандидатури по договор с болница!",
  EC_Invalid_Campaign_Sub_Type: "Невалиден подтип кампания за тази операция!",
  EC_Invalid_Campaign: "Невалидна кампания!",
  EC_Invalid_Campaign_Taxes: "Невалидни такси за кампанията!",
  EC_Invalid_Campaign_Taxes_Amount: "Невалидна сума за такса на кампанията!",
  EC_Invalid_Campaign_Name: "Моля, въведете име на кампанията на български и английски език!",
  EC_Missing_Argument_AdmissionNumberMarker: "Моля, въведете вх. номер!",
  EC_MaxLength_Reached_AdmissionNumberMarker_5: "Вх. номерът трябва да е до 5 символа!",
  EC_Invalid_Speciality_Candidates_Capacity: "Броят места за специалността трябва да е по-голям от 0!",
  EC_Pending_Request_Alreаdy_Exists: "Вече има чакаща заявка от този тип!",
  EC_Missing_Academic_Request_Document_Keys: "Липсват данни, необходими за генериране на документа!",
  EC_Missing_Declaration_Custom_Macros: "Моля попълнете всички задължителни полета за документа!",
  EC_Invalid_Declaration_Custom_Macros: "Избраната стойност за документа не е допустима!",
  EC_Missing_Argument_DataIssue: "Моля изберете тема на проблема с прехвърлените данни!",
  EC_Invalid_Argument_DataIssue:
    "Данни за проблем с прехвърлените данни могат да се подават само за заявка от този тип!",
  EC_NotFound_Academic_Request_Data_Issue_Topic: "Избраната тема не съществува!",
  EC_TooLong_Argument_Note: "Забележката трябва да е до 1000 символа!",

  // Dormitory — buildings
  EC_Missing_Argument_ResidentialNumber: "Моля, въведете номер на блока!",
  EC_TooLong_Argument_ResidentialNumber: "Номерът на блока трябва да е до 150 символа!",
  EC_Missing_Argument_HouseManagerEmployeeId: "Моля, изберете управител на блока!",
  EC_Invalid_Argument_HouseManagerEmployeeId: "Невалиден управител на блока!",
  EC_BuildingAlreadyExists: "Блок с този номер вече съществува!",
  EC_InvalidBuilding: "Невалиден блок!",
  EC_BuildingAlreadyActive: "Блокът вече е активен!",
  EC_BuildingAlreadyInactive: "Блокът вече е неактивен!",
  EC_BuildingHasActiveRooms: "Блокът има активни стаи и не може да бъде деактивиран!",

  // Weekly schedules — reschedule non-working occurrences
  EC_Reschedule_OriginalDate_Not_An_Occurrence: "Избраната дата не е занятие от седмичното разписание!",
  EC_Reschedule_OriginalDate_Not_NonWorking_Day: "Оригиналната дата не е почивен ден!",
  EC_Reschedule_OriginalDate_Not_In_Future: "Оригиналната дата на занятието трябва да е в бъдещето!",
  EC_Reschedule_NewDate_Not_In_Future: "Новата дата трябва да е в бъдещето!",
  EC_Reschedule_NewDate_Outside_Session_Period: "Новата дата е извън периода на семестъра!",
  EC_Reschedule_NewDate_NonWorking_Day: "Новата дата е почивен ден!",
  EC_Reschedule_ClassType_Not_Allowed: "Този тип занятие не може да бъде пренасрочвано!",
  EC_Reschedule_Duplicate_NewDate: "Групата вече има занятие, пренасрочено за тази дата!",
  EC_Reschedule_Class_Already_Generated: "Занятието за пренасрочената дата вече е генерирано и не може да се променя!",

  // Dormitory — rooms
  EC_Missing_Argument_RoomNumber: "Моля, въведете номер на стая!",
  EC_Invalid_Argument_RoomNumber: "Номерът на стаята трябва да е по-голям от 0!",
  EC_Missing_Argument_Floor: "Моля, въведете етаж!",
  EC_Invalid_Argument_Floor: "Етажът трябва да е по-голям от 0!",
  EC_Missing_Argument_BuildingId: "Моля, изберете блок!",
  EC_Invalid_Argument_BuildingId: "Невалиден блок!",
  EC_Missing_Argument_TypeId: "Моля, изберете тип стая!",
  EC_Invalid_Argument_TypeId: "Невалиден тип стая!",
  EC_Missing_Argument_ConditionId: "Моля, изберете състояние!",
  EC_Invalid_Argument_ConditionId: "Невалидно състояние на стая!",
  EC_Missing_Argument_Exposition: "Моля, изберете изложение!",
  EC_Invalid_Argument_Exposition: "Невалидно изложение!",
  EC_InvalidRoom: "Невалидна стая!",
  EC_InvalidRoomType: "Невалиден тип стая!",
  EC_InvalidRoomCondition: "Невалидно състояние на стая!",
  EC_RoomAlreadyExists: "Стая с този номер вече съществува в блока!",
  EC_RoomAlreadyActive: "Стаята вече е активна!",
  EC_RoomAlreadyInactive: "Стаята вече е неактивна!",
  EC_RoomInactive: "Стаята е неактивна!",
  EC_BuildingInactive: "Блокът е неактивен!",

  // Dormitory — room conditions
  EC_NotFound_RoomConditionEntity: "Състоянието на стаята не е намерено!",
  EC_RoomConditionAlreadyActive: "Състоянието на стаята вече е активно!",
  EC_RoomConditionAlreadyInactive: "Състоянието на стаята вече е неактивно!",
  EC_RoomConditionInactive: "Състоянието на стаята е неактивно!",
  EC_RoomConditionHasActiveRooms: "Състоянието на стаята има активни стаи и не може да бъде деактивирано!",
  EC_RoomConditionSystemManaged: "Състоянието се изчислява автоматично и не може да бъде променяно ръчно!",
  EC_RoomConditionNotManual: "Изберете ръчно състояние - автоматичните състояния не могат да се задават!",

  // Dormitory — room types
  EC_Missing_Argument_DescriptionBg: "Моля, въведете описание на български!",
  EC_TooLong_Argument_DescriptionBg: "Описанието на български трябва да е до 255 символа!",
  EC_Missing_Argument_DescriptionEn: "Моля, въведете описание на английски!",
  EC_TooLong_Argument_DescriptionEn: "Описанието на английски трябва да е до 255 символа!",
  EC_Missing_Argument_Capacity: "Моля, въведете брой места!",
  EC_Invalid_Argument_Capacity: "Броят места трябва да е по-голям от 0!",
  EC_Missing_Argument_Quadrature: "Моля, въведете квадратура!",
  EC_Invalid_Argument_Quadrature: "Квадратурата трябва да е по-голяма от 0!",
  EC_Missing_Argument_RoomRental: "Моля, въведете наем за цялата стая!",
  EC_Invalid_Argument_RoomRental: "Наемът за стаята не може да е отрицателен!",
  EC_Missing_Argument_CostPerPerson: "Моля, въведете наем на човек!",
  EC_Invalid_Argument_CostPerPerson: "Наемът на човек не може да е отрицателен!",
  EC_Missing_Argument_DiscountChild: "Моля, въведете отстъпка за едно дете!",
  EC_Invalid_Argument_DiscountChild: "Отстъпката за едно дете трябва да е между 0 и 100!",
  EC_Missing_Argument_DiscountChildren: "Моля, въведете отстъпка за две и повече деца!",
  EC_Invalid_Argument_DiscountChildren: "Отстъпката за две и повече деца трябва да е между 0 и 100!",
  EC_Missing_Argument_Terrace: "Моля, посочете дали стаята има тераса!",
  EC_Missing_Argument_SuitableForFamily: "Моля, посочете дали стаята е подходяща за семейство с деца!",
  EC_Missing_Argument_SuitableForDisabled: "Моля, посочете дали стаята е подходяща за хора с увреждания!",
  EC_RoomTypeAlreadyActive: "Типът стая вече е активен!",
  EC_RoomTypeAlreadyInactive: "Типът стая вече е неактивен!",
  EC_RoomTypeInactive: "Типът стая е неактивен!",
  EC_RoomTypeHasActiveRooms: "Типът стая има активни стаи и не може да бъде деактивиран!",

  // Dormitory — campaigns
  EC_Missing_Argument_NameBg: "Моля, въведете име на български!",
  EC_TooLong_Argument_NameBg: "Името на български трябва да е до 200 символа!",
  EC_Missing_Argument_NameEn: "Моля, въведете име на английски!",
  EC_TooLong_Argument_NameEn: "Името на английски трябва да е до 200 символа!",
  EC_NotFound_CampaignEntity: "Кампанията не е намерена!",
  EC_CampaignNotDraft: "Само кампания в статус „Чернова“ може да бъде потвърдена!",
  EC_CampaignNotConfirmed: "Само потвърдена кампания може да бъде приключена!",
  EC_CampaignFinished: "Приключена кампания не може да се редактира!",
  EC_CampaignCancelled: "Отказана кампания не може да се редактира!",
  EC_CampaignCannotBeCancelled: "Само кампания в статус „Чернова“ или „Потвърдена“ може да бъде отказана!",
  EC_Missing_Argument_CommissionChairEmployeeId: "Моля, изберете председател на комисията!",
  EC_Invalid_Argument_CommissionChairEmployeeId: "Невалиден председател на комисията!",
  EC_Missing_Argument_SessionDate: "Моля, изберете дата на заседание!",

  // Dormitory — accommodations (check-in / check-out)
  EC_InvalidApplication: "Невалидна молба!",
  EC_ApplicationNotAllocated: "Молбата не е одобрена и разпределена в стая!",
  EC_AccommodationAlreadyExists: "Студентът вече е настанен по тази молба!",
  EC_AccommodationAlreadyClosed: "Настаняването вече е приключено!",
  EC_StudentAlreadyAccommodated: "Студентът вече има активно настаняване!",
  EC_MovedInDateOutsideAccommodationWindow: "Датата на настаняване трябва да е в периода на настаняване по кампанията!",
  EC_RoomCapacityExceeded: "Стаята е запълнена като капацитет!",
  EC_Invalid_Argument_MovedOutAt: "Невалидна дата на напускане!",
  EC_MovedOutDateInFuture: "Датата на напускане не може да бъде в бъдещето!",
  EC_NotFound_AccommodationEntity: "Настаняването не е намерено!",

  // Dormitory — payments (recording and hotel reporting)
  EC_PaymentRequiresReview:
    "Сметката не е в състояние, което позволява записване на плащане. Презаредете и проверете състоянието ѝ!",
  EC_BillNotFound: "Сметката не е намерена!",
  EC_StudentIdentifierUnavailable: "Липсва идентификатор на студента в системата!",
  EC_Missing_Argument_Method: "Моля, изберете начин на плащане!",
  EC_Invalid_Argument_Method: "Невалиден начин на плащане!",
  EC_Missing_Argument_Reference: "Моля, въведете номер на документ или банкова референция!",
  EC_TooLong_Argument_Reference: "Референцията трябва да е до 500 символа!",
  EC_HotelBillingRequestFailed: "Изпращането към хотелската система не бе успешно!",

  // Dormitory — accommodation prices
  EC_Missing_Argument_Amount: "Моля, въведете цена!",
  EC_Invalid_Argument_Amount: "Цената трябва да е по-голяма от 0!",
  EC_TooLong_Argument_OrderNumber: "Номерът на заповед трябва да е до 100 символа!",
  EC_Missing_Argument_ReceptionTypeId: "Моля, изберете вид прием!",
  EC_Invalid_Argument_ReceptionTypeId: "Невалиден вид прием!",
  EC_Missing_Argument_StudentType: "Моля, изберете тип студент!",
  EC_Invalid_Argument_StudentType: "Невалиден тип студент!",
  EC_Missing_Argument_AccommodationId: "Моля, въведете настаняване!",
  EC_Invalid_Argument_AccommodationId: "Невалидно настаняване!",
  EC_Missing_Argument_Number: "Моля, въведете номер на заповедта!",
  EC_TooLong_Argument_Number: "Номерът на заповедта трябва да е до 100 символа!",
  EC_NotFound_AccommodationOrderEntity: "Настанителната заповед не е намерена!",
  EC_InvalidAccommodation: "Настаняването не е намерено!",
  EC_AccommodationInactive: "Настаняването не е активно!",
  EC_AccommodationOrderAlreadyExists: "Вече съществува настанителна заповед с този номер!",
  EC_AccommodationOrderNotDraft: "Само настанителна заповед в статус „Чернова“ може да бъде редактирана!",
  EC_AccommodationOrderCannotBeCancelled: "Само настанителна заповед в статус „Чернова“ може да бъде отказана!",
  EC_NotFound_RoomTypeEntity: "Типът стая не е намерен!",
  EC_NotFound_AccommodationPriceEntity: "Цената за настаняване не е намерена!",
  EC_NotFound_StateSubsidyEntity: "Държавната субсидия не е намерена!",

  // Dormitory — validity period and state subsidies
  EC_Missing_Argument_ValidFrom: "Моля, изберете начална дата!",
  EC_Missing_Argument_ValidTo: "Моля, изберете крайна дата!",
  EC_Invalid_Argument_ValidTo: "Крайната дата трябва да е след началната и в същата календарна година!",
  EC_StateSubsidyOverlappingPeriod: "Вече съществува субсидия за този период, вид прием и тип студент!",

  // Speciality annual fees
  EC_Missing_Annual_Fee_For_Admission_Year:
    "Няма въведени годишни такси за годината на прием на този курс! Въведете исторически план за съответната година през „Управление на годишни такси“.",
  EC_Duplicate_Annual_Paid_Education_Fee:
    "Има повече от един ред „платено обучение“ с еднакви гражданство, вид на обучение, език на обучение и основание за прием!",
  EC_Invalid_Argument_AdmissionYear: "Невалидна година на прием!",
  EC_Invalid_Argument_AdmissionReasonId: "Невалидно основание за прием!",
  EC_Missing_Argument_Citizenship: "Моля, изберете гражданство!",
  EC_Invalid_Argument_Citizenship: "Невалидно гражданство!",
  EC_Missing_Argument_TaxType: "Моля, изберете вид такса за всеки ред „платено обучение“!",
  EC_Invalid_Argument_TaxType: "Невалиден вид такса!",
  EC_Invalid_Argument_amount: "Моля, въведете сума — тя не може да бъде отрицателна!",
  EC_Invalid_Argument_BaseNormEuro: "БН се задава само при режим „По формула“ за български граждани!",
  EC_Invalid_Argument_StateFeeEuro: "Държавната такса се задава само при режим „По формула“ за български граждани!",
  EC_Invalid_Argument_ProfessionalFieldCoefficient: "КПН се задава само при режим „По формула“ за български граждани!",
  EC_Invalid_Argument_CompositeAssessmentCoefficient:
    "ККО се задава само при режим „По формула“ за български граждани!",
  EC_Invalid_Argument_DiscountAmountEuro: "Отстъпката се задава само при режим „По формула“ за български граждани!",
  EC_AccommodationPriceOverlappingPeriod:
    "Вече съществува цена за настаняване за този период, вид прием и тип студент!",

  // Add students to session exam
  EC_Invalid_Argument_Students: "Моля, добавете поне един студент!",
  EC_NotFound_SessionExamEntity: "Изпитът не съществува!",
  EC_SessionExamAddStudentsInvalidInput:
    "Няма намерено обучение за поне една двойка факултетен номер и специалност. Моля, проверете въведените данни!",
  EC_SessionExamIsMissingSlot: "Изпитът няма зададена дата и час!",
  EC_SessionExam_Already_Passed: "Изпитът вече е минал!",
  EC_Student_Already_Assigned_To_Exam: "Поне един студент вече е записан за този изпит!",

  // Health insurances
  EC_Invalid_Argument_Year: "Невалидна година!",
  EC_Invalid_Argument_Percentage: "Процентът трябва да е между 0 и 100 включително!",
  EC_HealthInsuranceEntity_Already_Exists: "Вече съществува запис с тази година и този месец!",

  // Study department info (EC_Missing_Argument_AddressEn is shared with the erasmus coordinators below)
  EC_Missing_Argument_AddressBg: "Моля попълнете адрес!",
  EC_Missing_Argument_WorkingTimeFrom: "Моля попълнете начало на работното време!",
  EC_Missing_Argument_WorkingTimeTo: "Моля попълнете край на работното време!",
  EC_Missing_Argument_EnrollmentDocumentsBg: "Моля попълнете документи за записване!",
  EC_Missing_Argument_EnrollmentDocumentsEn: "Моля попълнете документи за записване на английски!",

  // Erasmus coordinators
  EC_Missing_Argument_FacultyEn: "Моля попълнете факултет на латиница!",
  EC_Missing_Argument_AddressEn: "Моля попълнете адрес на латиница!",
  EC_Invalid_Argument_StructuralUnitId: "Невалидна структурна единица!",
  EC_Invalid_Argument_UniversityId: "Моля изберете университет!",
  EC_Invalid_Argument_SpecialtyId: "Моля изберете факултет!",
  EC_Invalid_Argument_MobilityVisitType: "Моля изберете тип визита!",
  EC_Invalid_Argument_Gender: "Моля изберете пол!",
  EC_Invalid_Argument_Email: "Невалиден имейл!",
  EC_Invalid_Argument_ErasmusCode: "Еразъм кодът трябва да е до 50 символа!",
  EC_Missing_Argument_BipName: "Моля попълнете BIP име!",
  EC_Missing_Argument_BipNumber: "Моля попълнете BIP номер!",
  EC_Missing_Argument_StartDate: "Моля попълнете начална дата!",
  EC_Missing_Argument_EndDate: "Моля попълнете крайна дата!",
  EC_Invalid_Argument_EndDate: "Крайната дата не може да е преди началната!",
  EC_Invalid_Argument_EmployeeId: "Невалиден служител!",
  EC_Invalid_Argument_Status: "Невалиден статус!",
  EC_Structural_Unit_Not_Found: "Избраният факултет не съществува в номенклатурата!",
  EC_NotFound_CoordinatorEntity: "Координаторът не съществува!",

  // Erasmus campaigns
  EC_Missing_Argument_CampaignSeason: "Моля изберете сезон на кампанията!",
  EC_Missing_Argument_CommissionMembers: "Моля добавете поне един член на комисията!",
  EC_Commission_Must_Have_Exactly_One_Chairman: "Комисията трябва да има точно един Председател!",
  EC_Duplicate_University_Ids: "Има дублиран университет в списъка!",
  EC_Missing_Argument_StructuralUnitId: "Моля изберете структурна единица!",
  EC_Academic_Year_Not_Found: "Избраната учебна година не съществува!",
  EC_Campaign_Season_Already_Exists: "Вече съществува кампания за този сезон, факултет и учебна година!",
  EC_Maximum_Stay_Cannot_Be_Null_Or_Empty: "Моля попълнете максимален престой за всеки университет!",

  EC_Invalid_Argument_FirstName: "Моля въведете валидно име!",
  EC_Invalid_Argument_LastName: "Моля въведете валидна фамилия!",
  EC_Invalid_Argument_FirstNameLatin: "Моля въведете валидно име на латиница!",
  EC_Invalid_Argument_LastNameLatin: "Моля въведете валидна фамилия на латиница!",
  EC_Invalid_Parameter_Email: "Моля въведете валиден имейл!",
  EC_Invalid_Argument_SpecialityId: "Невалидна специалност!",
  EC_Invalid_Argument_InstructionLanguageId: "Невалиден език на обучение!",
  EC_Invalid_Argument_CountryId: "Невалидна държава!",
  EC_Invalid_Argument_CoordinatorName: "Моля въведете име на координатор!",
  EC_Invalid_Argument_CoordinatorEmail: "Моля въведете валиден имейл на координатор!",
  EC_Invalid_Argument_SourceFaculty: "Моля въведете изпращащ факултет!",
  EC_Invalid_Argument_BirthDate: "Моля въведете дата на раждане!",
  EC_Missing_Argument_BipStartDate: "Моля въведете BIP начална дата!",
  EC_Missing_Argument_BipEndDate: "Моля въведете BIP крайна дата!",
  // Erasmus incoming internship students
  EC_Missing_Argument_UniversityName: "Моля изберете университет от списъка или въведете име на университет!",
  EC_Invalid_Argument_UniversityName: "Невалидно име на университет!",
  EC_Invalid_Parameter_Internships: "Моля добавете поне един стаж!",
  EC_Invalid_Parameter_Credits: "Моля попълнете кредити за задължителния стаж!",
  EC_Invalid_Mentor_Name_Or_Employee_Id: "Изберете преподавател ИЛИ въведете външен ментор, но не и двете!",
  EC_Invalid_Argument_HospitalBuildingId: "Невалидна болница!",
  EC_Invalid_Gender: "Невалиден пол!",
  EC_Invalid_CycleOfEducation: "Невалиден тип на обучение!",
  EC_Invalid_StructuralUnitId: "Невалиден факултет!",
  EC_Invalid_SpecialityId: "Невалидна специалност!",
  EC_Invalid_Course: "Невалиден курс!",
  EC_Invalid_Semester: "Невалиден семестър!",

  // Dormitory — missing backend messages
  EC_NotFound_BuildingEntity: "Блокът не е намерен!",
  EC_NotFound_RoomEntity: "Стаята не е намерена!",
  EC_NotFound_CampaignApplicationEntity: "Молбата не е намерена!",
  EC_Missing_Argument_ApplicationId: "Моля, въведете номер на молба!",
  EC_Invalid_Argument_ApplicationId: "Невалиден номер на молба!",
  EC_Missing_Argument_MovedInAt: "Моля, изберете дата на настаняване!",
  EC_Missing_Argument_MovedOutAt: "Моля, изберете дата на напускане!",
  EC_Missing_Argument_OrderNumber: "Моля, въведете номер на заповед!",
  EC_Missing_Argument_Course: "Моля, въведете курс!",
  EC_Invalid_Argument_Course: "Курсът е извън допустимия диапазон!",
  EC_Missing_Argument_RoomId: "Моля, изберете стая!",
  EC_Invalid_Argument_RoomId: "Невалидна стая!",
  EC_Missing_Argument_DocumentsFrom: "Моля, изберете начална дата за подаване на документи!",
  EC_Missing_Argument_DocumentsTo: "Моля, изберете крайна дата за подаване на документи!",
  EC_Invalid_Argument_DocumentsTo: "Крайната дата за подаване на документи трябва да е след началната!",
  EC_Missing_Argument_AccommodationFrom: "Моля, изберете начална дата за настаняване!",
  EC_Missing_Argument_AccommodationTo: "Моля, изберете крайна дата за настаняване!",
  EC_Invalid_Argument_AccommodationTo: "Крайната дата за настаняване трябва да е след началната!",
  EC_CampaignApplicationNotAllocatable: "Молбата може да бъде разпределена само когато е подадена или одобрена!",
  EC_CampaignApplicationNotSubmitted: "Само молба в статус „Подадена“ може да бъде неодобрена!",
  EC_StateSubsidyRequiresStateOrder: "Държавна субсидия се задава само за прием по държавна поръчка!",

  // Erasmus incoming internship students - coordinator approval
  EC_Invalid_Parameter_Locations: "Моля добавете поне една локация за всеки стаж!",
  EC_Invalid_Parameter_Location: "Локацията е твърде дълга!",
  EC_Internship_Not_Found: "Стажът не е намерен!",
  EC_Invalid_Parameter_NotifyHeadOfDepartment: "Нотификация може да се изпрати само при избран преподавател!",
  EC_Invalid_Parameter_ExternalMentorName: "Името на външния ментор е твърде дълго!",
  EC_Invalid_Parameter_Reason: "Причината е твърде дълга!",

  // Erasmus incoming internship students - arrival
  EC_Invalid_Parameter_Comment: "Коментарът не може да бъде по-дълъг от 500 символа!",

  // Dormitory lifecycle safeguards
  EC_AccommodationMoveChanged:
    "Преместването вече е променено от друг потребител. Моля, презаредете страницата и опитайте отново!",
  EC_CampaignStructuralFieldsLocked:
    "Видът кандидати и периодът за настаняване не могат да се променят след подаване на молби!",
  EC_CampaignNotEligibleForArrival: "Статусът на кампанията не позволява настаняване!",
  EC_ApplicationAppearanceDeadlineExpired: "Крайният срок за явяване по молбата е изтекъл!",
  EC_MovedInDateInFuture: "Датата на настаняване не може да бъде в бъдещето!",

  // NACID flows
  EC_Nacid_Flow_Not_Found: "Потокът към НАЦИД не е намерен!",
  EC_Nacid_Flow_Step_Not_Found: "Стъпката от потока не е намерена!",
  EC_Nacid_Flow_Not_Retryable:
    "Потокът не може да бъде рестартиран в текущия си статус. Рестартиране е възможно само за неуспешен, отказан или чакащ поток.",
  EC_Nacid_Flow_Already_Terminal: "Потокът вече е приключил и не може да бъде отказан.",
  EC_Nacid_Cancel_Note_Mandatory: "Въведете причина за отказа на потока!",
  EC_Nacid_Ean_Invalid: "Невалиден ЕАН! Очакват се две латински букви и пет цифри, например AB12345.",
  EC_Nacid_Step_Not_Awaiting_Manual_Action: "Стъпката не очаква ръчна намеса и не може да бъде разрешена ръчно.",
  EC_Nacid_Step_Not_Redoable: "Стъпката се изпълнява в момента и не може да бъде подадена повторно.",

  // Student education attestations management
  EC_Missing_Argument_Attestations: "Няма подадени заверки за запис!",
  EC_Invalid_Argument_Semester: "Невалиден семестър! Допустими са стойности от 1 до 12.",
  EC_Missing_Argument_Attestations_DisciplineId: "Липсва дисциплина за някоя от заверките!",
  EC_Invalid_Argument_Attestations_ClassTypeId: "Невалиден или несъвпадащ тип занятие за някоя от заверките!",
  EC_Invalid_Argument_Attestations_Status: "Невалиден статус за някоя от заверките!",
  EC_Invalid_Argument_Attestations_ProfessorEmployeeId: "Невалиден преподавател за някоя от заверките!",
  EC_Invalid_Argument_Attestations_Note: "Бележката към заверката не може да е по-дълга от 150 символа!",
  EC_Invalid_Argument_Attestations_Id: "Невалидна или повторена заверка в заявката!",
  EC_NotFound_StudentEducation: "Обучението не съществува!",
  EC_NotFound_Attestation: "Заверката не е намерена за това обучение и семестър!",
  EC_NotFound_StudentEducationCurriculum: "Обучението няма учебен план!",
  EC_Invalid_Argument_Attestations_DisciplineId: "Дисциплината не съвпада с тази на редактираната заверка!",
  EC_Attestation_Discipline_Not_In_Curriculum_Semester: "Дисциплината не се изучава в този семестър или курс!",
  EC_Attestation_Duplicate: "Вече съществува заверка за същата дисциплина, тип занятие и преподавател в този семестър!",
  EC_Not_Found_AcademicYear_Session:
    "Не може да се определи семестриалната сесия — в учебната година няма създаден такъв семестър!",

  // Graduated student documents — academic reference
  EC_Missing_Argument_FirstName: "Моля, въведете име!",
  EC_Missing_Argument_LastName: "Моля, въведете фамилия!",
  EC_Missing_Argument_FacultyNumber: "Моля, въведете факултетен номер!",
  EC_Missing_Argument_Specialty: "Моля, въведете специалност!",
  EC_Invalid_Argument_Semesters: "Невалидни данни за семестрите!",

  // Specialities — professional qualification
  EC_Missing_Argument_ProfessionalQualificationNameBg: "Моля, въведете професионална квалификация на български!",
  EC_Missing_Argument_ProfessionalQualificationNameEn: "Моля, въведете професионална квалификация на английски!",
  EC_TooLong_Argument_ProfessionalQualificationNameBg:
    "Професионалната квалификация на български трябва да е до 200 символа!",
  EC_TooLong_Argument_ProfessionalQualificationNameEn:
    "Професионалната квалификация на английски трябва да е до 200 символа!",

  // Accounts
  EC_Invalid_Request: "Невалидна заявка!",
  EC_Not_Satisfied_Password_Policy: "Паролата не отговаря на изискванията за сигурност!",
  EC_Changed_To_Same_Password: "Новата парола не може да съвпада със старата!",
  EC_Incorrect_Old_Password: "Старата парола е грешна!",
  EC_Incorrect_Current_Password: "Текущата парола е грешна!",
  EC_Secondary_Otp_Login: "Необходимо е потвърждение с еднократен код!",
  EC_Invalid_Recovery_Code: "Невалиден код за възстановяване!",
  EC_Expired_Recovery_Code: "Кодът за възстановяване е изтекъл!",
  EC_Invalid_Login_Credentials: "Невалидни данни за вход!",
  EC_Missing_ReCaptcha_Response: "Моля, потвърдете, че не сте робот!",
  EC_Email_Is_Required: "Моля, попълнете имейл!",
  EC_Invalid_Or_Missing_Email: "Моля, попълнете валиден имейл!",
  EC_User_Already_Exists: "Потребителят вече съществува!",
  EC_UserInfo_Already_Exists: "Данните за този потребител вече съществуват!",
  EC_PersonId_In_Use: "Това ЕГН вече се използва!",
  EC_Unspecified_User: "Моля, изберете потребител!",
  EC_Unspecified_User_Names: "Моля, попълнете имената на потребителя!",
  EC_Invalid_Min_Or_Max_Length_Names: "Имената не отговарят на позволената дължина!",
  EC_No_User_With_This_Email: "Няма потребител с този имейл!",
  EC_Same_Email: "Новият имейл съвпада с текущия!",
  EC_Unspecified_PersonId: "Моля, попълнете ЕГН!",
  EC_Unspecified_User_Gender: "Моля, изберете пол!",
  EC_Unspecified_User_Unique_Identifier: "Моля, попълнете уникален идентификатор на потребителя!",
  EC_Unable_To_Update_Info_Has_Approved_Candidacy:
    "Данните не могат да бъдат променени, защото потребителят има одобрена кандидатура!",
  EC_Unable_To_Update_Email_With_Password: "Имейлът на потребител с парола не може да бъде променен!",
  EC_Invalid_Permission_Name: "Невалидно име на право!",
  EC_Unspecified_Permissions: "Моля, изберете права!",
  EC_Not_Found_Permissions: "Правата не са намерени!",
  EC_Unspecified_Role: "Моля, изберете роля!",
  EC_Not_Found_Role: "Ролята не е намерена!",
  EC_Role_Already_Exists: "Такава роля вече съществува!",
  EC_Invalid_RoleName: "Невалидно име на роля!",
  EC_Invalid_RoleDescription: "Невалидно описание на роля!",
  EC_Unspecified_Roles: "Моля, изберете роли!",
  EC_Not_Found_Roles: "Ролите не са намерени!",
  EC_System_Error: "Възникна системна грешка. Моля, опитайте отново по-късно!",
  EC_Invalid_Email: "Невалиден имейл!",
  EC_Invalid_Code: "Невалиден код!",

  // Administration
  EC_Failed_To_Update_User_Info: "Данните на потребителя не можаха да бъдат обновени!",
  EC_Invalid_Or_Missing_Employee_Position_Name: "Моля, попълнете име на длъжността!",
  EC_Invalid_Or_Missing_Employee_Structural_Unit_Id: "Моля, изберете структурна единица на служителя!",
  EC_Invalid_Or_Missing_Employee_Structural_Unit_Name_Bg: "Моля, попълнете име на структурната единица на български!",
  EC_Invalid_Or_Missing_Employee_Structural_Unit_Name_En: "Моля, попълнете име на структурната единица на английски!",
  EC_Invalid_Or_Missing_Employee_ScientificDegree_Name: "Моля, попълнете име на научната степен!",
  EC_Invalid_Or_Missing_Id_Card_Detail_Number: "Моля, въведете номер на ЛК!",
  EC_Invalid_Or_Missing_Id_Card_Detail_Issued_On: "Моля, въведете дата на издаване на ЛК!",
  EC_Invalid_Or_Missing_Id_Card_Detail_Address: "Моля, въведете адрес по ЛК!",
  EC_Invalid_Or_Missing_Building_Bg_Name: "Моля, попълнете име на сградата на български!",
  EC_Invalid_Or_Missing_Building_En_Name: "Моля, попълнете име на сградата на английски!",
  EC_Invalid_Or_Missing_Building_Address: "Моля, попълнете адрес на сградата!",
  EC_Invalid_Or_Missing_Building_Latitude: "Моля, попълнете валидна географска ширина!",
  EC_Invalid_Or_Missing_Building_Longitude: "Моля, попълнете валидна географска дължина!",
  EC_Invalid_Or_Missing_Room_Floor: "Моля, попълнете етаж на залата!",
  EC_Invalid_Or_Missing_Room_Number: "Моля, попълнете номер на залата!",
  EC_Invalid_Or_Missing_Room_Department: "Моля, изберете катедра на залата!",
  EC_Invalid_Or_Missing_Room_Name_Bg: "Моля, попълнете име на залата на български!",
  EC_Invalid_Or_Missing_Room_Name_En: "Моля, попълнете име на залата на английски!",
  EC_Invalid_Or_Missing_Room_Capacity_Training: "Моля, попълнете валиден капацитет за обучение!",
  EC_Invalid_Or_Missing_Room_CapacityExam: "Моля, попълнете валиден капацитет за изпит!",
  EC_Invalid_Or_Missing_Room_Discipline: "Моля, изберете дисциплина за залата!",
  EC_Invalid_Or_Missing_Technical_Equipment_Type_Name_Bg:
    "Моля, попълнете име на вида техническо оборудване на български!",
  EC_Invalid_Or_Missing_Technical_Equipment_Type_Name_En:
    "Моля, попълнете име на вида техническо оборудване на английски!",
  EC_Invalid_Or_Missing_Exam_Name_Bg: "Моля, попълнете име на изпита на български!",
  EC_Invalid_Or_Missing_Exam_Name_En: "Моля, попълнете име на изпита на английски!",
  EC_Invalid_Or_Missing_Exam_Type_Id: "Моля, изберете вид изпит!",
  EC_Invalid_Or_Missing_Exam_Category_Id: "Моля, изберете категория на изпита!",
  EC_Invalid_Or_Missing_Direction_Name_Bg: "Моля, попълнете име на направлението на български!",
  EC_Invalid_Or_Missing_Direction_Name_En: "Моля, попълнете име на направлението на английски!",
  EC_Invalid_StudyType_Id: "Невалидна форма на обучение!",
  EC_Invalid_Degree_Id: "Невалидна образователна степен!",
  EC_Invalid_Instruction_Language_Id: "Невалиден език на обучение!",
  EC_NotFound_Instruction_Language: "Езикът на обучение не е намерен!",
  EC_NotFound_Specific_Requirement: "Специфичното изискване не е намерено!",
  EC_Invalid_Or_Missing_Department_Name_Bg: "Моля, попълнете име на катедрата на български!",
  EC_Invalid_Or_Missing_Department_Name_En: "Моля, попълнете име на катедрата на английски!",
  EC_Invalid_Or_Missing_Can_Candidate_With_Different_Exams:
    "Моля, посочете дали се допуска кандидатстване с различни изпити!",
  EC_Invalid_Or_Missing_Name_Bg: "Моля, попълнете име на български!",
  EC_Invalid_Or_Missing_Name_En: "Моля, попълнете име на английски!",
  EC_Invalid_Or_Missing_Preference_Name_Bg: "Моля, попълнете име на предимството на български!",
  EC_Invalid_Or_Missing_Preference_Name_En: "Моля, попълнете име на предимството на английски!",
  EC_Invalid_Or_Missing_Preference_Ids: "Моля, изберете предимства!",
  EC_Invalid_Or_Missing_ScientificDegree_Name_Bg: "Моля, попълнете име на научната степен на български!",
  EC_Invalid_Or_Missing_ScientificDegree_Name_En: "Моля, попълнете име на научната степен на английски!",
  EC_Invalid_Or_Missing_ScientificDegree_Short_Name_Bg: "Моля, попълнете съкращение на научната степен на български!",
  EC_Invalid_Or_Missing_ScientificDegree_Short_Name_En: "Моля, попълнете съкращение на научната степен на английски!",
  EC_Invalid_Negative_Or_Zero_Discount_Percentage: "Процентът на отстъпката трябва да е по-голям от нула!",
  EC_Invalid_Negative_Or_Zero_Preference_Document_Type_Count:
    "Броят документи за предимството трябва да е по-голям от нула!",
  EC_Invalid_Citizen_Type: "Невалиден тип гражданство!",
  EC_Not_Active_Direction: "Направлението не е активно!",
  EC_Type_Not_Found: "Видът не е намерен!",
  EC_Technical_Equipment_Type_Not_Found: "Видът техническо оборудване не е намерен!",
  EC_Exam_Not_Found: "Изпитът не е намерен!",
  EC_Building_Not_Found: "Сградата не е намерена!",
  EC_Position_Not_Found: "Длъжността не е намерена!",
  EC_Position_Type_Is_Required: "Моля, изберете вид длъжност!",
  EC_Position_Type_Not_Found: "Видът длъжност не е намерен!",
  EC_Inactive_Substitute_Position: "Неактивни длъжности не могат да бъдат добавяни като заместници при одобрение!",
  EC_Missing_Argument_SubstitutePositionIds: "Липсва списък със заместващи длъжности!",
  EC_Room_Not_Found: "Залата не е намерена!",
  EC_Not_Found_Speciality: "Специалността не е намерена!",
  EC_Invalid_Structural_Unit_Id: "Невалидна структурна единица!",
  EC_Invalid_Professional_Direction_Id: "Невалидно професионално направление!",
  EC_ScientificDegree_Not_Found: "Научната степен не е намерена!",
  EC_Not_Found_Directions: "Не са намерени направления!",
  EC_Not_Found_Rooms: "Не са намерени зали!",
  EC_Not_Found_Employee_Types: "Не са намерени видове служители!",
  EC_Not_Found_Employee_Positions: "Не са намерени длъжности!",
  EC_Not_Found_Buildings: "Не са намерени сгради!",
  EC_Not_Found_Employee_ScientificDegrees: "Не са намерени научни степени!",
  EC_Not_Found_Employees: "Не са намерени служители!",
  EC_Not_Found_Study_Types: "Не са намерени форми на обучение!",
  EC_Not_Found_Reception_Types: "Не са намерени видове прием!",
  EC_Not_Found_Degrees: "Не са намерени образователни степени!",
  EC_Not_Found_Exams: "Не са намерени изпити!",
  EC_Not_Found_Disciplines: "Не са намерени дисциплини!",
  EC_Not_Found_Technical_Equipment_Types: "Не са намерени видове техническо оборудване!",
  EC_Not_Found_Room_Class_Types: "Не са намерени видове занятия за залата!",
  EC_Not_Found_Class_Types: "Не са намерени видове занятия!",
  EC_Not_Found_Room_Types: "Не са намерени видове зали!",
  EC_Not_Found_Tax_Types: "Не са намерени видове такси!",
  EC_Not_Found_Preference_Document_Types: "Не са намерени видове документи за предимство!",
  EC_Preference_Not_Found: "Предимството не е намерено!",
  EC_Not_Found_Intermediary: "Посредникът не е намерен!",
  EC_Not_Found_Document_Type: "Видът документ не е намерен!",
  EC_Not_Available_Tecnical_Equipment: "Избраното техническо оборудване не е налично!",
  EC_Not_Specified_Exams: "Моля, изберете изпити!",
  EC_Not_Specified_Specialities: "Моля, изберете специалности!",
  EC_Invalid_Exams: "Невалидни изпити!",
  EC_Invalid_Or_Missing_Speciality_Name_Bg: "Моля, попълнете име на специалността на български!",
  EC_Invalid_Or_Missing_Speciality_Name_En: "Моля, попълнете име на специалността на английски!",
  EC_Invalid_Or_Missing_Intermediary_Company_Name: "Моля, попълнете име на фирмата посредник!",
  EC_Invalid_Or_Missing_Intermediary_Person_Name: "Моля, попълнете име на лицето за контакт!",
  EC_Invalid_Or_Missing_Intermediary_Phone_Number: "Моля, попълнете валиден телефонен номер на посредника!",
  EC_Professional_Direction_Not_Found: "Професионалното направление не е намерено!",
  EC_Professional_Direction_Name_Bg_Required: "Моля, попълнете име на професионалното направление на български!",
  EC_Missing_Annual_Fee: "Липсва годишна такса!",
  EC_Duplicate_Annual_State_Education_Fee: "Вече съществува годишна такса за държавна поръчка за тази година!",
  EC_Description_Mandatory: "Моля, попълнете описание!",
  EC_Invalid_Or_Missing_Discipline_Name_Bg: "Моля, попълнете име на дисциплината на български!",
  EC_Invalid_Or_Missing_Discipline_Name_En: "Моля, попълнете име на дисциплината на английски!",
  EC_Not_Found_Discipline: "Дисциплината не е намерена!",
  EC_Invalid_Or_Missing_Discipline_Category: "Моля, изберете категория на дисциплината!",
  EC_Not_Found_Countries: "Не са намерени държави!",
  EC_Same_Country_In_Pair: "Двете държави в двойката не могат да са еднакви!",
  EC_Duplicate_Country_Pair: "Тази двойка държави вече съществува!",
  EC_Invalid_Country_Id: "Невалидна държава!",
  EC_Invalid_Or_Missing_Id: "Невалиден или липсващ идентификатор!",
  EC_Not_Found_Settlement: "Населеното място не е намерено!",
  EC_Not_Found_Country: "Държавата не е намерена!",
  EC_Not_Found_District: "Областта не е намерена!",
  EC_Not_Found_Municipality: "Общината не е намерена!",
  EC_Invalid_File: "Невалиден файл!",
  EC_Invalid_Or_Missing_Specific_Requirement_Name_Bg: "Моля, попълнете име на специфичното изискване на български!",
  EC_Invalid_Or_Missing_Specific_Requirement_Name_En: "Моля, попълнете име на специфичното изискване на английски!",
  EC_Group_Specification_Not_Found: "Спецификацията на групата не е намерена!",
  EC_Group_Specifications_MinSize_Required: "Моля, попълнете минимален брой в групата!",
  EC_Group_Specifications_MaxSize_Required: "Моля, попълнете максимален брой в групата!",
  EC_Group_Specifications_MinSize_Invalid_Value: "Невалиден минимален брой в групата!",
  EC_Group_Specifications_MaxSize_Invalid_Value: "Невалиден максимален брой в групата!",
  EC_Group_Specifications_Size_Invalid_Range: "Минималният брой в групата трябва да е по-малък от максималния!",
  EC_GradingScale_Not_Found: "Скалата за оценяване не е намерена!",
  EC_Invalid_Or_Missing_GradingScale_Name: "Моля, попълнете име на скалата за оценяване!",
  EC_Invalid_Or_Missing_GradingScale_MaxPoints: "Моля, попълнете валиден максимален брой точки!",
  EC_Invalid_Or_Missing_Practice_Name_Bg: "Моля, попълнете име на практиката на български!",
  EC_Invalid_Or_Missing_Practice_Name_En: "Моля, попълнете име на практиката на английски!",
  EC_Not_Found_Practice: "Практиката не е намерена!",
  EC_Invalid_Or_Missing_StateExam_Name_Bg: "Моля, попълнете име на държавния изпит на български!",
  EC_Invalid_Or_Missing_StateExam_Name_En: "Моля, попълнете име на държавния изпит на английски!",
  EC_Not_Found_StateExam: "Държавният изпит не е намерен!",
  EC_Invalid_Or_Missing_Internship_Name_Bg: "Моля, попълнете име на стажа на български!",
  EC_Invalid_Or_Missing_Internship_Name_En: "Моля, попълнете име на стажа на английски!",
  EC_Not_Found_Internship: "Стажът не е намерен!",
  EC_Invalid_Or_Missing_Internship_Type: "Моля, изберете вид стаж!",
  EC_Invalid_Or_Missing_Topic_Name_Bg: "Моля, попълнете име на темата на български!",
  EC_Not_Found_Topic: "Темата не е намерена!",
  EC_Speciality_Already_In_Group: "Специалността вече е добавена в групата!",
  EC_Time_Period_Required: "Моля, въведете период!",

  // Alumni
  EC_Invalid_Constact_Email: "Моля, попълнете валиден имейл за контакт!",
  EC_Invalid_Speciality: "Невалидна специалност!",
  EC_Invalid_Invalid_Phone_Number: "Моля, попълнете валиден телефонен номер!",
  EC_Invalid_Employer: "Моля, попълнете валиден работодател!",
  EC_Active_Status: "Профилът вече е в статус „Активен“!",
  EC_Rejected_Status: "Профилът вече е в статус „Отхвърлен“!",
  EC_Status_Not_Correct: "Невалиден статус!",
  EC_Gender_Not_Correct: "Невалиден пол!",
  EC_Invalid_FirstName: "Моля, попълнете валидно име!",
  EC_Invalid_SecondName: "Моля, попълнете валидно презиме!",
  EC_Invalid_LastName: "Моля, попълнете валидна фамилия!",
  EC_Invalid_Group: "Невалидна група!",
  EC_Invalid_Events: "Невалидни събития!",
  EC_Invalid_Diploma_Year: "Невалидна година на дипломиране!",
  EC_Invalid_Semester_Completion_Year: "Невалидна година на семестриално завършване!",
  EC_Role_Not_Added: "Ролята не беше добавена!",
  EC_Correction_Not_Found: "Корекцията не е намерена!",
  EC_Correction_Applied: "Корекцията вече е приложена!",
  EC_Status_Applied: "Профилът вече е в този статус!",
  EC_Invalid_Redis_Key: "Заявката е изтекла. Моля, опитайте отново!",
  EC_Invalid_Password: "Невалидна парола!",
  EC_Property_NotFound: "Полето не е намерено!",
  EC_Invalid_Value: "Невалидна стойност!",
  EC_Invalid_Title: "Моля, въведете заглавие!",
  EC_Invalid_Sub_Title: "Моля, въведете подзаглавие!",
  EC_Alumni_Not_Found: "Алумни профилът не е намерен!",
  EC_User_Not_Found: "Потребителят не е намерен!",
  EC_User_Server_Error: "Възникна грешка при работата с потребителските данни!",
  EC_Email_Not_Found: "Имейлът не е намерен!",

  // Candidate
  EC_Expired_Workflow: "Сесията е изтекла. Моля, започнете отначало!",
  EC_Missing_Correlation_Id: "Липсва идентификатор на заявката. Моля, започнете отначало!",
  EC_Invalid_Correlation_Id: "Невалиден идентификатор на заявката. Моля, започнете отначало!",
  EC_First_Name_Is_Required: "Моля, попълнете име!",
  EC_First_Name_Invalid_Longitude: "Невалидна дължина на името!",
  EC_Second_Name_Invalid_Longitude: "Невалидна дължина на презимето!",
  EC_Last_Name_Is_Required: "Моля, попълнете фамилия!",
  EC_Last_Name_Invalid_Longitude: "Невалидна дължина на фамилията!",
  EC_Invalid_Country: "Невалидна държава!",
  EC_Gender_Invalid: "Невалиден пол!",
  EC_Not_Found_Child_Campaign: "Свързаната кампания не е намерена!",
  EC_Declarations_Not_Accepted: "Моля, приемете декларациите!",
  EC_Invalid_Campaign_Exam: "Невалиден изпит за кампанията!",
  EC_Invalid_Campaign_Exams: "Невалидни изпити за кампанията!",
  EC_Not_Found_Campaign_Courses: "Не са намерени курсове за кампанията!",
  EC_Invalid_Campaign_Courses: "Невалидни курсове за кампанията!",
  EC_Invalid_Start_Or_EndDate: "Началната дата трябва да е преди крайната!",
  EC_Invalid_Start_Or_EndTime: "Началният час трябва да е преди крайния!",
  EC_Updated_Room_Has_Candidates: "Не можете да редактирате зала, в която има кандидати!",
  EC_No_Debts_For_Candidacy: "Няма задължения за тази кандидатура!",
  EC_Invalid_Campaign_Exam_Rooms: "Невалидни зали за изпита!",
  EC_Invalid_Campaign_Exam_Room: "Невалидна зала за изпита!",
  EC_Invalid_Child_Campaign_Id: "Невалидна свързана кампания!",
  EC_Required_Speciality_Paid_Education_Capacity: "Моля, попълнете капацитет за платено обучение на специалността!",
  EC_Invalid_Speciality_Structural_Unit: "Невалидна структурна единица за специалността!",
  EC_Picked_Specialities_With_Different_Exams: "Избраните специалности изискват различни изпити!",
  EC_Not_Picked_Mandatory_Speciality_Exam: "Кандидатът не е избрал задължителния изпит за специалността!",
  EC_Picked_Forbidden_Speciality_Exam: "Избран е изпит, който не е позволен за специалността!",
  EC_Speciality_Divisions_Not_Found: "Не са намерени раздели за специалността!",
  EC_Invalid_Score_Line_Components: "Невалидни компоненти на балообразуването!",
  EC_Invalid_Speciality_Study_Type: "Невалидна форма на обучение за специалността!",
  EC_Not_Participated_In_Child_Campaign: "Кандидатът не е участвал в свързаната кампания!",
  EC_Already_Candidate_For_Campaign: "Вече има подадена кандидатура за тази кампания!",
  EC_Missing_Declaration_Documents: "Липсват документи към декларациите!",
  EC_Invalid_Campaign_Already_Started_Or_Ongoing: "Кампанията вече е започнала или е в ход!",
  EC_Campaign_Finished: "Кампанията е приключила!",
  EC_Required_Regular_Campaign_Spoken_Exam_Start_Time: "Моля, попълнете начален час на устния изпит!",
  EC_Required_Regular_Campaign_Spoken_Exam_Overlapping_Time_Slots: "Времевите интервали на устния изпит се застъпват!",
  EC_Invalid_Campaign_Room_Priority: "Невалиден приоритет на залата!",
  EC_Invalid_Campaign_Rooms: "Невалидни зали за кампанията!",
  EC_Required_Campaign_Exam_Timestamp: "Моля, попълнете дата и час на изпита!",
  EC_Invalid_Money_Currency: "Невалидна валута!",
  EC_Transaction_Id_Invalid: "Невалиден номер на транзакция!",
  EC_Transaction_Reference_Invalid: "Невалидна референция на транзакция!",
  EC_Transaction_Not_Found: "Транзакцията не е намерена!",
  EC_Invalid_Candidacy_Request: "Невалидна заявка за кандидатура!",
  EC_Invalid_Candidacy_State: "Невалиден статус на кандидатурата!",
  EC_Invalid_Candidacy: "Невалидна кандидатура!",
  EC_NotFound_CandidacyUserId: "Потребителят на кандидатурата не е намерен!",
  EC_UnableToComplete_Campaign_Application: "Кандидатурата не може да бъде завършена!",
  EC_Invalid_Exam_To_Enroll_For_Candidacy: "Невалиден изпит за записване по тази кандидатура!",
  EC_Invalid_Course_To_Enroll_For_Candidacy: "Невалиден курс за записване по тази кандидатура!",
  EC_Invalid_Candidacy_Exam: "Невалиден изпит за кандидатурата!",
  EC_Invalid_Candidacy_Exam_Room: "Невалидна зала за изпита на кандидатурата!",
  EC_Invalid_Candidacy_Exam_Room_Candidacy: "Кандидатурата не е разпределена в тази зала!",
  EC_Invalid_Candidacy_Number: "Невалиден входящ номер!",
  EC_Invalid_Candidacy_Name: "Невалидно име на кандидатурата!",
  EC_Not_Found_Candidacy_Exam_Slot: "Не е намерено място за изпита на кандидатурата!",
  EC_Not_Found_Candidacy_Exam: "Изпитът на кандидатурата не е намерен!",
  EC_Not_Found_Campaign_Exam_Slot: "Не е намерено място за изпита в кампанията!",
  EC_Invalid_Preferences: "Невалидни предимства!",
  EC_Missing_Preference: "Моля, изберете предимство!",
  EC_Missing_Preference_Doc_Type: "Моля, изберете вид документ за предимството!",
  EC_Not_Uploaded_Preference_Documents: "Моля, прикачете документи за предимството!",
  EC_Invalid_Preference_Data: "Невалидни данни за предимството!",
  EC_Missing_Laureate: "Моля, изберете лауреатство!",
  EC_Missing_Laureate_Doc_Type: "Моля, изберете вид документ за лауреатството!",
  EC_Not_Uploaded_Laureate_Documents: "Моля, прикачете документи за лауреатството!",
  EC_Missing_Diploma_Documents: "Моля, прикачете документи за дипломата!",
  EC_Missing_Reinstate_Rights_Documents: "Моля, прикачете документи за възстановяване на права!",
  EC_Bank_Transfer_Transaction_Not_Found: "Транзакцията за банков превод не е намерена!",
  EC_Bank_Transfer_Statement_Upload_Failed: "Банковото извлечение не можа да бъде качено!",
  EC_Document_Already_Uploaded: "Документът вече е качен!",
  EC_Campaign_Exam_Not_Found: "Изпитът от кампанията не е намерен!",
  EC_Campaign_Exam_User_Info_Not_Found: "Не са намерени данни за кандидата по този изпит!",
  EC_Not_Specified_User: "Моля, изберете потребител!",
  EC_SchoolSubject_Duplicate_Id: "Учебният предмет е посочен повече от веднъж!",
  EC_SchoolSubject_Not_Found: "Учебният предмет не е намерен!",
  EC_Invalid_Or_Missing_SchoolSubject_Name_Bg: "Моля, попълнете име на учебния предмет на български!",
  EC_Invalid_Or_Missing_SchoolSubject_Name_En: "Моля, попълнете име на учебния предмет на английски!",
  EC_Missing_Candidacy_Correction_Fields: "Моля, изберете полета за корекция!",
  EC_Invalid_Candidacy_Correction_Fields: "Невалидни полета за корекция!",
  EC_Invalid_Candidacy_Correction_Hash: "Невалиден линк за корекция!",
  EC_Candidacy_Correction_Already_Submitted: "Корекцията вече е изпратена!",
  EC_Candidacy_Correction_User_Info_Not_Updated: "Данните на кандидата не бяха обновени!",
  EC_Candidacy_Correction_Field_Not_Requested: "За това поле не е заявена корекция!",
  EC_Invalid_Declaration_Documents: "Невалидни документи към декларациите!",
  EC_Candidacy_Show_User_Info_Not_Updated: "Данните на кандидата не бяха обновени в кандидатурата!",
  EC_Invalid_Or_Missing_Multiplier_Value: "Моля, попълнете валиден коефициент!",
  EC_Invalid_School_Grade: "Невалидна училищна оценка!",
  EC_Invalid_Grade: "Невалидна оценка!",
  EC_Invalid_Grade_Status_Combination: "Оценката не отговаря на избрания статус!",
  EC_File_Null_Or_Empty: "Моля, прикачете файл!",
  EC_Exam_Result_Not_Found: "Резултатът от изпита не е намерен!",
  EC_Exam_Price_Not_Found: "Не е намерена цена за изпита!",
  EC_Course_Price_Not_Found: "Не е намерена цена за курса!",
  EC_Speciality_Price_Not_Found: "Не е намерена цена за специалността!",
  EC_Invalid_Exams_Count: "Невалиден брой изпити!",
  EC_Missing_Price_Euro: "Моля, попълнете цена в евро!",
  EC_Invalid_Price_Euro: "Невалидна цена в евро!",
  EC_Invalid_Price_Leva: "Невалидна цена в лева!",
  EC_Unable_To_Create_Transaction: "Транзакцията не можа да бъде създадена!",
  EC_Unable_To_Get_Transaction: "Транзакцията не можа да бъде заредена!",
  EC_No_Campaign_For_Registration: "Няма активна кампания за регистрация!",
  EC_More_Than_One_Campaign_For_Registration: "Има повече от една активна кампания за регистрация!",
  EC_Speciality_Is_Required: "Моля, изберете специалност!",
  EC_Candidacy_Specialities_Not_Found: "Не са намерени специалности за кандидатурата!",
  EC_Invalid_Speciality_For_Candidacy: "Невалидна специалност за кандидатурата!",
  EC_Duplicate_Speciality: "Специалността е посочена повече от веднъж!",
  EC_Invalid_Priority_Sequence: "Невалидна последователност на приоритетите!",
  EC_Already_Enrolled: "Кандидатът вече е записан!",
  EC_Not_Eligible_For_Student_Enrollment: "Кандидатът няма право да бъде записан като студент!",
  EC_Required_Birth_Settlement: "Моля, попълнете населено място по рождение!",
  EC_Required_Residence_Street: "Моля, попълнете улица по постоянен адрес!",
  EC_Required_Birth_Country: "Моля, изберете държава по рождение!",
  EC_Required_Birth_Date: "Моля, попълнете дата на раждане!",
  EC_Education_Fee_Type_Required: "Моля, изберете вид такса за обучение!",
  EC_Invalid_Candidate_Course: "Невалиден курс за кандидата!",
  EC_Invalid_Candidate_Enrollment_Declaration_Documents: "Невалидни документи към декларациите за записване!",
  EC_Unable_To_Create_Student: "Студентът не можа да бъде създаден!",
  EC_Unable_To_Candidate_For_Campaign: "Не може да се подаде кандидатура за тази кампания!",
  EC_CanNotCandidate_When_RemovedFromExam: "Не може да се кандидатства след отстраняване от изпита!",
  EC_Missing_Campaign_Tax: "Липсва такса за кампанията!",
  EC_Invalid_Payment_Method_For_Expectation: "Невалиден начин на плащане за това очаквано плащане!",
  EC_No_Payment_Expectation_For_Candidacy: "Няма очаквано плащане за тази кандидатура!",
  EC_No_Candidacy_Payment_To_Transfer: "Няма плащане по кандидатурата, което да бъде прехвърлено!",
  EC_Unsupported_Payment_Provider_For_Payment_Expectation:
    "Този доставчик на плащания не се поддържа за очакваното плащане!",
  EC_Not_Available_Protocol_For_This_Candidacy: "За тази кандидатура няма наличен протокол!",
  EC_PaymentEshop_Not_Found: "Плащането не е намерено в системата за онлайн плащания!",
  EC_Candidacy_For_Campaign_Already_Exists: "Вече съществува кандидатура за тази кампания!",
  EC_Unable_To_Retrieve_Debt_Statuses: "Статусите на задълженията не можаха да бъдат заредени!",
  EC_Unable_To_Create_Candidate_Enrollment_Debt: "Задължението за записване не можа да бъде създадено!",
  EC_Candidacy_Has_No_Accepted_Ranking_Result: "Кандидатурата няма прието класиране!",
  EC_Student_Education_Not_Paid: "Обучението на студента не е платено!",

  // CareerCenter
  EC_Invalid_Type: "Невалиден тип обява!",
  EC_Invalid_Category: "Невалидна категория!",
  EC_Invalid_Employment_Type: "Невалиден тип заетост!",
  EC_Invalid_Contract_Type: "Невалиден тип договор!",
  EC_Invalid_Application_Method: "Невалиден начин на кандидатстване!",
  EC_Invalid_CandidateType: "Невалиден тип кандидат!",
  EC_Invalid_Candidate_Types: "Невалидни типове кандидати!",
  EC_Invalid_Position: "Моля, попълнете длъжност!",
  EC_Invalid_Salary: "Моля, попълнете валидна заплата!",
  EC_Invalid_Position_Description: "Моля, попълнете описание на длъжността!",
  EC_Invalid_Requirements: "Моля, попълнете изисквания към кандидатите!",
  EC_Invalid_Company_Offers: "Моля, попълнете какво предлага фирмата!",
  EC_Invalid_Application_Documents: "Моля, посочете необходимите документи за кандидатстване!",
  EC_Invalid_Job_Offer_Specialities: "Невалидни специалности за обявата!",
  EC_Invalid_Valid_Until: "Моля, въведете валидна дата, до която обявата е публикувана!",
  EC_Job_Not_Found: "Обявата не е намерена!",
  EC_Manually_Stopped: "Обявата вече е спряна ръчно!",
  EC_Document_Service_Error: "Възникна грешка при работата с документите!",
  EC_Invalid_District: "Моля, попълнете квартал!",
  EC_Invalid_Address: "Моля, попълнете адрес!",
  EC_Invalid_Settlement: "Моля, изберете населено място!",
  EC_Invalid_Contact_Person: "Моля, попълнете лице за контакт!",
  EC_Invalid_Contact_Person_Phone: "Моля, попълнете валиден телефон на лицето за контакт!",
  EC_Invalid_Contact_Phone: "Моля, попълнете валиден телефон за контакт!",
  EC_Invalid_Contact_Email: "Моля, попълнете валиден имейл за контакт!",
  EC_Invalid_EmployerId: "Невалиден работодател!",
  EC_Employer_Not_Found: "Работодателят не е намерен!",
  EC_Employer_Not_Found_Or_Not_Active: "Работодателят не е намерен или не е активен!",
  EC_Invalid_Company_Name: "Моля, попълнете име на фирмата!",
  EC_Invalid_Bulstat: "Моля, попълнете валиден Булстат!",
  EC_Invalid_Management_Address: "Моля, попълнете адрес на управление!",
  EC_Invalid_Mol: "Моля, попълнете МОЛ!",
  EC_Invalid_Number_Of_Employees: "Моля, попълнете валиден брой служители!",
  EC_Invalid_Organization_Description: "Моля, попълнете описание на организацията!",
  EC_Speciality_Not_Found: "Специалността не е намерена!",
  EC_Graduated_Student_Not_Found: "Завършилият студент не е намерен!",
  EC_Education_Not_Correct: "Невалидни данни за образованието!",
  EC_User_Applied: "Вече има подадена кандидатура по тази обява!",
  EC_User_Id_Not_Found: "Потребителят не е намерен!",
  EC_Account_Server_Error: "Възникна грешка при работата с потребителските данни!",
  EC_Property_Not_Found: "Полето не е намерено!",
  EC_Filter_Not_Found: "Филтърът не е намерен!",

  // Debt
  EC_Debt_Not_Found: "Задължението не е намерено!",
  EC_Eshop_Not_Found: "Плащането не е намерено в системата за онлайн плащания!",
  EC_Debt_Cancelled: "Задължението е анулирано!",
  EC_Debt_Already_Paid: "Задължението вече е платено!",

  // Document
  EC_Invalid_Document_Name: "Моля, попълнете име на документа!",
  EC_Invalid_File_Name: "Невалидно име на файла!",
  EC_Invalid_Document_SubCategory: "Невалидна подкатегория на документа!",
  EC_Not_Provided_File: "Моля, прикачете файл!",
  EC_File_Not_Exists: "Файлът не съществува!",
  EC_Bg_File_Not_Found: "Липсва файл на български език!",
  EC_En_File_Not_Found: "Липсва файл на английски език!",
  EC_Static_Document_Not_Found: "Документът не е намерен!",
  EC_Declaration_Not_Found: "Декларацията не е намерена!",
  EC_Invalid_Declaration_Name: "Моля, попълнете име на декларацията!",
  EC_Too_Long_Declaration_Name: "Името на декларацията е твърде дълго!",
  EC_Declaration_Invalid_Preview_Id: "Невалиден документ за преглед на декларацията!",
  EC_No_Documents_For_Declaration: "Няма документи за тази декларация!",

  // Dormitory — campaign applications and registration
  EC_CampaignNotAcceptingApplications: "Кампанията не приема молби в момента!",
  EC_CampaignApplicationAlreadyExists: "Вече има подадена молба за тази кампания!",
  EC_StudentHasActiveApplicationOnOtherCampaign: "Студентът има активна молба по друга кампания!",
  EC_NotEligibleApplicant: "Кандидатът не отговаря на условията за тази кампания!",
  EC_CampaignApplicantTypeMismatch: "Видът кандидат не съответства на кампанията!",
  EC_CampaignApplicationVerificationDocumentMissing: "Липсва документ за верификация към молбата!",
  EC_VerificationDocumentUploadFailed: "Качването на документа за верификация не бе успешно!",
  EC_VerificationDocumentDownloadFailed: "Свалянето на документа за верификация не бе успешно!",
  EC_EmailAlreadyInUse: "Този имейл вече се използва!",
  EC_InvalidRegistrationHash: "Невалиден линк за регистрация!",
  EC_InvalidOriginUniversity: "Невалиден университет!",
  EC_ResidentProfileNotFound: "Профилът на живеещия не е намерен!",
  EC_ProfileNotEditable: "Профилът не може да бъде редактиран!",
  EC_NoCurrentAcademicYear: "Няма текуща учебна година!",
  EC_NextAcademicYearNotFound: "Следващата учебна година не е намерена!",

  // Dormitory — reservations
  EC_AccommodationAlreadyReserved: "Настаняването вече е резервирано!",
  EC_ReservationWindowClosed: "Периодът за резервация е приключил!",
  EC_AccommodationNotOwnedByStudent: "Настаняването не принадлежи на този студент!",

  // Dormitory — bills and prepayments
  EC_BillNotPending: "Сметката не е в статус „Неплатена“!",
  EC_OlderBillUnpaid: "Има по-стара неплатена сметка, която трябва да бъде платена първо!",
  EC_NoBillToDeriveAmount: "Няма сметка, от която да бъде определена сумата!",
  EC_PrepayExceedsAcademicYear: "Предплащането надхвърля края на учебната година!",
  EC_PrepaymentRequestPayloadMismatch: "Данните на заявката за предплащане не съвпадат!",
  EC_PaymentSelectionAlreadyStarted: "Вече има започнат избор за плащане!",
  EC_PaymentNotPaid: "Плащането не е отбелязано като платено!",
  EC_DebtNotPayable: "Задължението не може да бъде платено!",

  // Employee
  EC_Employee_Is_Inactive: "Служителят е неактивен!",
  EC_Employee_Already_Active: "Служителят вече е активен!",
  EC_Employee_Already_Inactive: "Служителят вече е неактивен!",
  EC_Employee_Already_Exist: "Служителят вече съществува!",
  EC_Employee_Id_Required: "Моля, изберете служител!",
  EC_Manager_Not_Found: "Ръководителят не е намерен!",
  EC_Manager_Already_Exist: "Вече има определен ръководител!",
  EC_Not_Found_Position_In_Node: "Длъжността не е намерена в тази част от структурата!",
  EC_Tree_Node_Already_Exists: "Тази част от структурата вече съществува!",

  // Employee — staff requests
  EC_Staff_Request_Not_Found: "Заявката не е намерена!",
  EC_Staff_Request_Self_Approval_Not_Allowed: "Собствена заявка не може да бъде одобрена!",
  EC_Staff_Request_Cancellation_Already_Pending: "Вече има подадена заявка за отмяна!",
  EC_Erasmus_Signature_Request_Already_Pending: "Вече има подадена заявка за подпис по Еразъм!",
  EC_Invalid_Period_Holiday_Or_Weekend: "Периодът не може да бъде в почивен или празничен ден!",
  EC_Substitute_Employee_Required: "Моля, изберете заместник!",
  EC_StatusReason_NotFound: "Причината за статуса не е намерена!",
  EC_Missing_Required_StatusReason: "Моля, въведете причина за статуса!",

  // Employee — leaves and sick leaves
  EC_Leave_Request_Not_Found: "Заявката за отпуск не е намерена!",
  EC_Leave_Request_Already_Closed: "Заявката за отпуск вече е приключена!",
  EC_Leave_Reason_Not_Found: "Основанието за отпуск не е намерено!",
  EC_Leave_Periods_Overlap: "Периодите на отпуск се застъпват!",
  EC_Leave_Period_Cannot_Be_Extended: "Периодът на отпуск не може да бъде удължен!",
  EC_New_Leave_Period_Cannot_Be_Added: "Не може да бъде добавен нов период на отпуск!",
  EC_Insufficient_Leave_Balance: "Оставащият отпуск не е достатъчен за този период!",
  EC_Leave_Document_Not_Found: "Документът към отпуска не е намерен!",
  EC_Max_Leave_Attachments_Exceeded: "Достигнат е максималният брой прикачени документи!",
  EC_Sick_Leave_Request_Not_Found: "Болничният не е намерен!",
  EC_Failed_To_Upload_Sick_Leave_Document: "Документът за болничен не можа да бъде качен!",

  // Employee — business trips
  EC_Business_Trip_Request_Not_Found: "Командировката не е намерена!",
  EC_Business_Trip_Request_Already_Closed: "Командировката вече е приключена!",
  EC_Business_Trip_Request_Not_Completed: "Командировката не е попълнена докрай!",
  EC_Business_Trip_Template_Key_Already_Exists: "Вече съществува шаблон с този ключ!",

  // Erasmus
  EC_Invalid_University_Id: "Невалиден университет!",
  EC_Invalid_Specialty_Id: "Невалидна специалност!",
  EC_Invalid_Employee_Id: "Невалиден служител!",
  EC_Campaign_Not_Active: "Кампанията не е активна!",
  EC_Invalid_Semester_For_Season: "Семестърът не отговаря на сезона на кампанията!",
  EC_Invalid_Academic_Year_For_Season: "Учебната година не отговаря на сезона на кампанията!",
  EC_Traineeship_Minimum_Duration: "Продължителността на стажа е под минимално допустимата!",
  EC_Signature_Request_Already_Pending: "Вече има подадена заявка за подпис!",
  EC_Discipline_Change_Window_Expired: "Срокът за промяна на дисциплините е изтекъл!",
  EC_Absence_Dates_Required: "Моля, въведете начало и край на отсъствието!",
  EC_Invalid_Or_Missing_Weekly_Schedule: "Моля, попълнете валидно седмично разписание!",
  EC_Student_Not_Synced: "Данните на студента не са синхронизирани!",

  // Google
  EC_Course_Name_Is_Required: "Моля, попълнете име на Google залата!",
  EC_Course_Not_Found: "Google залата не е намерена!",
  EC_Failed_Create_Course_In_Google_Service: "Google залата не можа да бъде създадена в Google!",
  EC_Failed_To_Create_Course_In_Database: "Google залата не можа да бъде записана в системата!",
  EC_CourseWork_Not_Found: "Заданието не е намерено!",
  EC_Participant_Not_Found: "Участникът не е намерен!",
  EC_Invalid_staff_role: "Невалидна роля на служител!",
  EC_Users_Are_Required: "Моля, изберете поне един потребител!",
  EC_Too_Many_Users_In_Batch: "Твърде много потребители в една заявка!",
  EC_Duplicate_User_In_Batch: "Потребител е посочен повече от веднъж!",
  EC_MissingGoogleEmailForBulkCreation: "Липсва Google имейл за част от избраните потребители!",
  EC_Failed_To_Create_Google_User: "Google акаунтът не можа да бъде създаден!",
  EC_Failed_To_Load_User_Names: "Имената на потребителите не можаха да бъдат заредени!",

  // Graduation — internship sessions
  EC_SameInternshipSessionExists: "Вече съществува стажантска сесия с тези параметри!",
  EC_InternshipSessionNotFound: "Стажантската сесия не е намерена!",
  EC_InternshipSessionAlreadyFinalized: "Стажантската сесия вече е финализирана!",

  // Graduation — schedules
  EC_ScheduleCycleDatesOutOfRange: "Датите на цикъла са извън периода на стажантската сесия!",
  EC_ScheduleInvalidDisciplinesBasedOnPlan: "Дисциплините не съответстват на стажантския план!",
  EC_ScheduleIndividualSlotNotFound: "Индивидуалният слот не е намерен!",
  EC_ScheduleIndividualSlotTimeConflict: "Индивидуалният слот се застъпва с друг слот!",
  EC_ScheduleIndividualSlotDisciplineNotIndividual: "Дисциплината не е с индивидуално разписание!",
  EC_ScheduleIndividualSlotAssignmentDuplicateSlot: "Слотът е посочен повече от веднъж!",
  EC_ScheduleIndividualSlotAssignmentDuplicateStudent: "Студентът е посочен повече от веднъж!",
  EC_ScheduleFreeSelectionSlotNotFound: "Слотът за свободен избор не е намерен!",
  EC_ScheduleFreeSelectionSlotDisciplineNotFreeHourSelection: "Дисциплината не е със свободен избор на часове!",
  EC_ScheduleFreeSelectionSlotCapacityExceeded: "Капацитетът на слота е запълнен!",
  EC_ScheduleFreeSelectionSlotStudentAlreadyAssigned: "Студентът вече е записан за този слот!",
  EC_ScheduleFreeSelectionSlotAssignmentNotFound: "Записването за слота не е намерено!",
  EC_ScheduleFreeSelectionSlotDateOutOfSessionRange: "Датата на слота е извън периода на стажантската сесия!",
  EC_ScheduleIndividualCycleNotFound: "Индивидуалният цикъл не е намерен!",
  EC_ScheduleIndividualCycleDisciplineNotIndividualCycles: "Дисциплината не е с индивидуални цикли!",
  EC_ScheduleIndividualCycleStudentPlanMismatch: "Стажантският план на студента не съответства на цикъла!",
  EC_ScheduleIndividualCycleStartSlotNotInCycle: "Началният слот не принадлежи на този цикъл!",
  EC_ScheduleIndividualCycleStudentAlreadyAssigned: "Студентът вече е разпределен в този цикъл!",

  // Graduation — state exams
  EC_StateExamNotFound: "Държавният изпит не е намерен!",
  EC_NoneExistingStateExam: "Посочен е несъществуващ държавен изпит!",
  EC_DuplicateStateExamIds: "Държавен изпит е посочен повече от веднъж!",
  EC_InvalidStateExamSlotTimestamp: "Невалидна дата и час на държавния изпит!",
  EC_StateExamNotSelectable: "Този държавен изпит не може да бъде избран!",
  EC_StateExamStudyGroupsNotAllowed: "За този държавен изпит не се допускат учебни групи!",
  EC_InvalidStateExamAssignmentType: "Невалиден тип разпределение за държавния изпит!",
  EC_StateExamStudentsCourseMismatch: "Студентите не са от един и същи курс!",
  EC_StateExamStudentsInstructionLanguageMismatch: "Студентите не са с един и същи език на обучение!",
  EC_StudentAlreadyEnrolledInStateExam: "Студентът вече е записан за този държавен изпит!",
  EC_StudentAlreadyEnrolledInStateExamGroup: "Студентът вече е записан в група за този държавен изпит!",
  EC_StudentNotEnrolledForStateExam: "Студентът не е записан за този държавен изпит!",
  EC_OneOrMoreStudentsNotEnrolledInStateExam: "Един или повече студенти не са записани за този държавен изпит!",
  EC_StudentStateExamResultNotFound: "Резултатът на студента от държавния изпит не е намерен!",
  EC_StateExamResultAlreadyExists: "Вече съществува резултат за този държавен изпит!",
  EC_InvalidStateExamResultStatusCombination: "Оценката не отговаря на избрания статус!",
  EC_UnableToGradeStateExamNotYetCompleted: "Държавният изпит още не е проведен и не може да бъде оценен!",
  EC_UnableToGradeStateExamStudentDefendingThesis:
    "Студентът защитава дипломна работа и не може да бъде оценен на държавен изпит!",

  // Graduation — training bases
  EC_TrainingBaseNotFound: "Учебната база не е намерена!",
  EC_TrainingBaseSourceSessionEmpty: "В избраната сесия няма учебни бази за клониране!",
  EC_StudentAssignmentDuplicateTrainingBase: "Учебната база е посочена повече от веднъж!",
  EC_StudentAssignmentTrainingBaseNotInSession: "Учебната база не принадлежи на тази стажантска сесия!",
  EC_StudentAssignmentTrainingBaseAlreadyAssigned: "Студентът вече е назначен в тази учебна база!",
  EC_StudentTrainingBaseNotFound: "Назначението на студента в учебна база не е намерено!",

  // Graduation — thesis defense
  EC_ThesisDefenseRequestNotFound: "Заявката за защита на дипломна работа не е намерена!",
  EC_ThesisDefenseRequestAlreadyExists: "Вече съществува заявка за защита на дипломна работа!",
  EC_ThesisDefenseRequestNotPending: "Заявката за защита вече е обработена!",
  EC_ThesisDefenseDateNotFound: "Датата на защита не е намерена!",

  // Notification
  EC_Not_Found_Email_Group: "Имейл групата не е намерена!",
  EC_Invalid_Email_Group_Name: "Моля, попълнете име на групата!",
  EC_Email_Group_Name_Exists: "Вече съществува имейл група с това име!",
  EC_Invalid_Email_Group_Description: "Невалидно описание на групата!",
  EC_Not_Found_Email: "Имейлът не е намерен!",
  EC_Unspecified_Email_Correlation_Ids: "Моля, изберете поне един имейл!",
  EC_Not_Found_Email_Correlation_Ids: "Част от посочените имейли не са намерени!",
  EC_Not_Found_User_Notification: "Нотификацията не е намерена!",

  // Payment
  EC_PaymentProvider_Not_Found: "Доставчикът на плащания не е намерен!",
  EC_PaymentProvider_Not_Active: "Доставчикът на плащания не е активен!",
  EC_Borica_Terminal_Not_Found: "Терминалът в Борика не е намерен!",
  EC_Borica_Status_Check_Error: "Проверката на статуса в Борика не бе успешна!",
  EC_Epay_Merchant_Not_Found: "Търговецът в ePay не е намерен!",
  EC_Invalid_Transaction_OrderId: "Невалиден номер на поръчка за транзакцията!",
  EC_Invalid_Transaction_Signature: "Невалиден подпис на транзакцията!",
  EC_Invalid_Get_Transaction_Status_Request: "Невалидна заявка за проверка на статуса на транзакцията!",
  EC_Unable_To_Reverse_Transaction: "Транзакцията не може да бъде сторнирана!",
  EC_Unable_To_Create_Bank_Transfer: "Банковият превод не можа да бъде създаден!",
  EC_Unable_To_Create_Cash_Transaction: "Плащането в брой не можа да бъде записано!",
  EC_Iban_Not_Found: "IBAN не е намерен!",
  EC_Iban_Invalid: "Невалиден IBAN!",
  EC_BicCode_Invalid: "Невалиден BIC код!",
  EC_Debt_Amount_Mismatch: "Сумата не съответства на избраните задължения!",
  EC_Debt_Not_Payable: "Задължението не може да бъде платено!",
  EC_Debt_Hashes_Must_Belong_To_Single_Eshop:
    "Избраните задължения трябва да са към една и съща система за онлайн плащания!",
  EC_Payment_Debt_Hashes_Must_Belong_To_Single_User: "Избраните задължения трябва да са на един и същ потребител!",

  // Reporting
  EC_ReportNotImplemented: "Тази справка все още не е реализирана!",
  EC_InvalidReportFilter: "Невалидни параметри за справката!",
  EC_PagedListExportTooLarge: "Твърде много редове за експорт. Моля, стеснете филтъра!",
  EC_PagedListExportMappingFailed: "Данните не можаха да бъдат подготвени за експорт!",
  EC_EntityNotFound: "Записът не е намерен!",
  EC_NotFound: "Търсеният ресурс не е намерен!",
  EC_Forbidden: "Нямате достъп до тази операция!",

  // Scholarship
  EC_Missing_Document_Files: "Моля, прикачете необходимите документи!",
  EC_Blacklisted_Student: "Студентът е в черен списък!",
  EC_Already_Approved_Application: "Кандидатурата вече е одобрена!",
  EC_Insufficient_Average_Grade: "Средният успех е недостатъчен!",
  EC_Already_Blocked_Application: "Кандидатурата вече е блокирана!",
  EC_Application_Process_Still_Active: "Процесът по кандидатстване още не е приключил!",
  EC_Invalid_Scholarship_Application_Status: "Невалиден статус на кандидатурата за стипендия!",

  // Specialist
  EC_SpecializationFeeMustHaveOneFromAnnualOrMonthly: "Таксата трябва да бъде или годишна, или месечна!",
  EC_TrainingBuildingAlreadyHasAccreditationForSpecialization:
    "Базата за обучение вече има акредитация за тази специалност!",

  // Student — records
  EC_Id_Mandatory: "Моля, посочете идентификатор!",
  EC_Not_Found_Student: "Студентът не е намерен!",
  EC_Not_Found_Student_Education_Semester: "Семестърът от обучението не е намерен!",
  EC_Not_Found_Student_Education_Id: "Обучението на студента не е намерено!",
  EC_Not_Found_Student_Previous_Education: "Предходното образование на студента не е намерено!",
  EC_Not_Found_UserData: "Данните на потребителя не са намерени!",
  EC_Missing_Exact_Match_Search_Criteria: "Моля, въведете критерий за точно търсене!",
  EC_EGN_Mandatory: "Моля, попълнете ЕГН!",
  EC_Same_Course: "Студентът вече е в този курс!",
  EC_Same_Dormitory_Usage: "Ползването на общежитие вече е с тази стойност!",
  EC_Same_Reception_Type: "Видът прием вече е същият!",
  EC_Student_Already_Enrolled_For_Speciality: "Студентът вече е записан за тази специалност!",
  EC_Student_Exists: "Студентът вече съществува!",
  EC_Request_Invalid: "Невалидна заявка!",
  EC_NoData_Found: "Няма намерени данни!",
  EC_BgEn_Names_Differ: "Имената на български и на английски трябва да са попълнени и двете!",

  // Student — mandatory fields
  EC_UserId_Mandatory: "Моля, посочете потребител!",
  EC_Name_Mandatory: "Моля, попълнете име!",
  EC_UinOrLnch_Mandatory: "Моля, попълнете ЕГН или ЛНЧ!",
  EC_Email_Mandatory: "Моля, попълнете имейл!",
  EC_Phone_Mandatory: "Моля, попълнете телефон!",
  EC_Gender_Mandatory: "Моля, изберете пол!",
  EC_BirthCountry_Mandatory: "Моля, изберете държава по рождение!",
  EC_Settlement_Mandatory: "Моля, изберете населено място!",
  EC_ResidenceSettlement_Mandatory: "Моля, изберете населено място по постоянен адрес!",
  EC_ResidenceCountry_Mandatory: "Моля, изберете държава по постоянен адрес!",
  EC_PassportCopy_Mandatory: "Моля, прикачете копие на паспорт!",
  EC_Citizenship_Invalid: "Невалидно гражданство!",

  // Student — curriculum selection campaigns
  EC_CurriculumSelectionCampaign_Not_Available: "Кампанията за избор на учебен план не е активна!",
  EC_Invalid_CurriculumSelectionCampaign_Priority: "Невалиден приоритет в кампанията за избор на учебен план!",
  EC_Already_Applied_For_CurriculumSelectionCampaign: "Вече има подадена заявка за тази кампания!",
  EC_CurriculumSelectionCampaign_Has_Applications: "Кампанията има подадени заявки и не може да бъде променена!",
  EC_CurriculumSelectionCampaign_ApplicationPeriod_Not_Ended: "Периодът за подаване на заявки още не е приключил!",

  // Student — academic year
  EC_Invalid_Or_Missing_StructuralUnitId: "Моля, изберете структурна единица!",
  EC_Invalid_Or_Missing_Courses: "Моля, посочете курсове!",
  EC_Invalid_Or_Missing_StudentType: "Моля, изберете тип студент!",
  EC_Invalid_Or_Missing_LectureStreams: "Моля, посочете брой лекционни потоци!",
  EC_Invalid_Or_Missing_TypeId: "Моля, изберете тип!",
  EC_Invalid_Or_Missing_Name: "Моля, попълнете име!",
  EC_Invalid_Start_Or_EndDate_StartDate: "Началната дата трябва да е преди крайната!",
  EC_Not_Found_SessionId: "Сесията не е намерена!",
  EC_Not_Found_Year_Type: "Типът учебна година не е намерен!",

  // Student — attestations
  EC_Attestation_Signing_OnlyForSingleDiscipline: "Заверки могат да се подписват само за една дисциплина наведнъж!",
  EC_Attestation_Signing_OnlyForSingleSemester: "Заверки могат да се подписват само за един семестър наведнъж!",

  // Student — curriculum, mandatory fields
  EC_CurriculumDisciplineInfo_Mandatory: "Моля, попълнете данните за дисциплината от учебния план!",
  EC_CurriculumDiscipline_Mandatory: "Моля, изберете дисциплина от учебния план!",
  EC_Discipline_Mandatory: "Моля, изберете дисциплина!",
  EC_DisciplineType_Mandatory: "Моля, изберете тип дисциплина!",
  EC_YearsOfStudy_Mandatory: "Моля, посочете години на обучение!",
  EC_Semester_Mandatory: "Моля, изберете семестър!",
  EC_Speciality_Mandatory: "Моля, изберете специалност!",
  EC_InstructionLanguage_Mandatory: "Моля, изберете език на обучение!",
  EC_Citizenship_Mandatory: "Моля, изберете гражданство!",
  EC_Credit_Mandatory: "Моля, попълнете кредити!",
  EC_TotalCredits_Mandatory: "Моля, попълнете общ брой кредити!",
  EC_Hours_Mandatory: "Моля, попълнете брой часове!",
  EC_Occupancy_Mandatory: "Моля, попълнете натовареност!",
  EC_Number_Mandatory: "Моля, попълнете номер!",
  EC_Note_Mandatory: "Моля, попълнете забележка!",
  EC_ValidFrom_Mandatory: "Моля, попълнете дата на валидност!",
  EC_DocumentId_Mandatory: "Моля, прикачете документ!",

  // Student — curriculum, invalid and duplicate
  EC_Invalid_CurriculumDisciplineInfo: "Невалидни данни за дисциплината от учебния план!",
  EC_Invalid_CurriculumDiscipline: "Избрана е дисциплина, която не принадлежи на учебния план!",
  EC_Invalid_CurriculumDiscipline_Semesters: "Невалидни семестри за дисциплината от учебния план!",
  EC_Duplicate_CurriculumElectiveGroupDiscipline:
    "Една и съща дисциплина е добавена в избираемата група повече от веднъж!",
  EC_Duplicate_SpecialityAffectedYear: "Една и съща година е посочена повече от веднъж за специалността!",
  EC_Duplicate_CurriculumPractice: "Една и съща практика е добавена повече от веднъж!",
  EC_Duplicate_CurriculumStateExam: "Един и същ държавен изпит е добавен повече от веднъж!",
  EC_Duplicate_CurriculumThesis: "Една и съща дипломна работа е добавена повече от веднъж!",
  EC_Invalid_Missing_Speciality: "Моля, изберете валидна специалност!",
  EC_Invalid_Missing_Degree: "Моля, изберете образователна степен!",
  EC_Invalid_Missing_Ean: "Моля, попълнете валиден EAN!",
  EC_Invalid_Missing_ExtracurricularActivities: "Невалидни извънаудиторни занятия!",
  EC_Invalid_Missing_GradingMethod: "Моля, изберете начин на оценяване!",
  EC_Invalid_Missing_FormOfControl: "Моля, изберете форма на контрол!",

  // Student — curriculum, not found
  EC_Not_Found_YearOfStudy: "Годината на обучение не е намерена!",
  EC_Not_Found_Curriculum_Practice: "Практиката от учебния план не е намерена!",
  EC_Not_Found_Degree: "Образователната степен не е намерена!",
  EC_Not_Found_InstructionLanguage: "Езикът на обучение не е намерен!",
  EC_Not_Found_GradingMethod: "Начинът на оценяване не е намерен!",
  EC_Curriculum_Current: "Учебният план е текущ и не може да бъде променен!",
  EC_ValidFrom_Present: "Моля, попълнете дата на валидност!",

  // Student — weekly schedules
  EC_Invalid_Or_Missing_Discipline: "Моля, изберете дисциплина!",
  EC_Invalid_Or_Missing_Room: "Моля, изберете зала!",
  EC_Invalid_Or_Missing_StudyGroup: "Моля, изберете учебна група!",
  EC_Invalid_Or_Missing_WeeklySchedule: "Невалидно седмично разписание!",
  EC_Room_And_Online_Mutually_Exclusive: "Изберете зала ИЛИ онлайн занятие, но не и двете!",
  EC_Invalid_Week_Day: "Невалиден ден от седмицата!",
  EC_Invalid_Week_Number: "Невалиден номер на седмица!",
  EC_Invalid_TimeSpan: "Невалиден времеви интервал!",
  EC_Weekly_Schedule_Time_Conflict: "Има застъпване с друго занятие в този диапазон!",
  EC_WeeklySchedule_Invalid_WeeksSequence: "Невалидна последователност на седмиците!",
  EC_Invalid_Schedule_Professors_Week_Sequence: "Невалидна последователност на седмиците за преподавателите!",
  EC_UnableToSplit_Exercise_Schedule_Without_Groups:
    "Разписанието за упражнение не може да бъде разделено без учебни групи!",
  EC_UnableToSplit_Not_Exercise_Schedule: "Само разписание за упражнение може да бъде разделено!",
  EC_StudyGroups_Not_Allowed_For_Pickable_Schedule: "Учебни групи не се допускат за разписание с избираеми дисциплини!",

  // Student — session exams
  EC_SessionExam_UnableToEnroll: "Записването за изпита не е възможно!",
  EC_SessionExam_UnableToEnroll_HasNotSignedOffDiscipline: "Дисциплината няма заверка и записване не е възможно!",
  EC_SessionExam_AlreadyEnrolled: "Студентът вече е записан за този изпит!",
  EC_SessionExam_Enrollment_Closed: "Записването за този изпит е затворено!",
  EC_SessionExam_Capacity_Reached: "Капацитетът на изпита е запълнен!",
  EC_SessionExam_Not_In_FacultyNumber_Range: "Факултетният номер на студента е извън обхвата за този изпит!",
  EC_Invalid_Exam_Times: "Невалидни часове на изпита!",

  // Student — academic requests and decisions
  EC_Pending_Request_Already_Exists: "Вече има чакаща заявка!",
  EC_Unsupported_Education_Status_For_Academic_Report:
    "Статусът на обучение не позволява издаване на академична справка!",
  EC_Missing_IdCard_Details: "Липсват данни за лична карта!",
  EC_Unable_To_Fetch_Student_HealthCare_Status: "Здравноосигурителният статус на студента не можа да бъде зареден!",
  EC_Status_Change_Reason_Not_Found: "Основанието за промяна на статуса не е намерено!",

  // Student — cyclic schedules and exam assignment
  EC_Cyclic_Schedule_Already_Exists: "Вече съществува циклично разписание за въведените параметри!",
  EC_Student_Has_Pending_Exam_For_Discipline: "Студентът има незавършен изпит по тази дисциплина!",
  EC_Discipline_Already_Passed: "Дисциплината вече е положена!",
  EC_Discipline_Already_Taken_This_Year: "Дисциплината вече е явявана тази учебна година!",
  EC_FacultyNumber_Generation_Failed: "Факултетният номер не можа да бъде генериран!",

  // Student — class attendance
  EC_ClassAttendance_QrCode_Invalid_Or_Expired: "QR кодът е невалиден или изтекъл!",
  EC_Student_Not_Expected_For_Class: "Студентът не е включен в това занятие!",
  EC_ClassAttendance_Already_Marked_Present: "Присъствието вече е отбелязано!",
  EC_ClassAttendance_Already_Marked_Absent: "Отсъствието вече е отбелязано!",
  EC_ClassAttendance_In_MakeUp_Flow: "Занятието е в процес на отработване!",
  EC_ClassAttendance_Already_Marked_MadeUp: "Занятието вече е отбелязано като отработено!",
  EC_UnableTo_Request_MakeUp: "Не може да бъде подадена заявка за отработване!",
  EC_Not_Enough_Absences_To_Request_MakeUp: "Няма достатъчно отсъствия за заявка за отработване!",
  EC_Existing_Pending_MakeUp_Request: "Вече има чакаща заявка за отработване!",
  EC_Unable_To_Determine_MakeUp_Request_Recipient: "Не може да бъде определен получател на заявката за отработване!",

  // Student — pickable curriculum disciplines
  EC_Missing_RequiredElectiveGroupDisciplines: "Моля, изберете дисциплини от задължителните избираеми групи!",
  EC_Invalid_Discipline_For_Selected_Elective_Group: "Дисциплината не принадлежи на избраната избираема група!",
  EC_Invalid_Discipline_For_Selected_Facultative: "Дисциплината не е факултативна!",
  EC_Invalid_PickableDisciplines_Count: "Невалиден брой избрани дисциплини!",

  // Student — Google Classroom sync
  EC_Missing_Google_Course_Ref: "Липсва връзка към Google зала!",
  EC_Missing_Google_Course_Work_Ref: "Липсва връзка към задание в Google!",
  EC_Missing_Session_Exam_Meeting_Info: "Липсват данни за онлайн срещата на изпита!",
  EC_Missing_Google_Calendar_EventId: "Липсва идентификатор на събитие в Google Календар!",
  EC_Session_Exam_Not_Online: "Изпитът не е онлайн!",
  EC_Position_Based_Profiles_Disabled: "Изборът на профил не е активен за този университет.",
  EC_Profile_Switch_Not_Allowed: "Смяната на профил не е налична за този потребител.",
  EC_Employee_Profile_Not_Found: "Избраният профил не е намерен.",
  EC_Role_Not_Found: "Една или повече от избраните роли не съществуват.",
  EC_Failed_To_Resolve_Roles: "Неуспешно зареждане на ролите. Опитайте отново.",
};

export default errorMessages;
